{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Pestañas de selección de idioma del formulario"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "No tiene derechos suficientes para acceder a esta página."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Calendario",
    "URL_WITH_EVENT": "{description} \n Unirse a la videoconferencia: {url}"
  },
  "ANONYMOUS": "Anónimo",
  "API_SAUCE": {
    "CANCEL_ERROR": "La solicitud del servidor ha sido interrumpida.",
    "CLIENT_ERROR": "Ups, ocurrió un error inesperado.",
    "CONNECTION_ERROR": "El servidor no está disponible.",
    "NETWORK_ERROR": "Error de red, verifique su conexión.",
    "SERVER_ERROR": "Ups, ha ocurrido un error inesperado.",
    "TIMEOUT_ERROR": "El servidor no respondió a tiempo."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "No publicado",
    "PUBLICATION_ALERT": "Programado el {date} a las {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Foto del responsable",
    "TITLE": "Responsable"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Elige un administrador",
    "TITLE": "Asignar el procesamiento de esta contribución"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "No podemos eliminar este archivo adjunto.",
      "TITLE": "Error - "
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Participo",
    "ATTENDING": "Inscrito"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "Acepto la <terms>política de privacidad</terms> de {spaceName}.",
    "ACCEPT_SPACE_TERMS": "Acepto los <privacy>términos de uso</privacy> de {spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "Acepto <privacy>la política de privacidad</privacy> y <terms>los términos de uso</terms> de {spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "Acepto la {privacy} y los {terms} de Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Registrarse con {provider}",
    "AUTH_LIST_TITLE": "Servicios de autenticación de terceros",
    "BACKGROUND_ALT": "Ilustración de fondo",
    "CONTINUE_WITHOUT_SIGNUP": "Continuar sin cuenta",
    "DELETE_TOAST": "El servicio de autenticación de terceros se ha desconectado correctamente.",
    "DESCRIPTION": "Su registro en Fluicity Engage le permitirá participar en las consultas sobre {spaceName} y le dará acceso a otras consultas organizadas en Fluicity Engage. Para obtener más información sobre la gestión de sus datos personales y ejercer sus derechos, consulte nuestra <b>Política de Privacidad.</b>",
    "EMAIL_PLACEHOLDER": "ejemplo@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "Al unirse a <strong>{spaceName}</strong>, recibirá información sobre las últimas consultas y noticias.<br></br><br></br>También puede ayudar a comprender mejor si la actividad es representativa de la población global compartiendo alguna información:",
      "TITLE": "Unirse a {spaceName} !"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Configure una contraseña para eliminar este servicio de autenticación de terceros.",
      "DELETE_AUTH_FAILED": "No hemos podido eliminar este servicio de autenticación de terceros.",
      "INVALID_EMAIL": "El formato de su dirección de correo electrónico es incorrecto.",
      "NO_ASSOCIATED_ACCOUNT": "Ninguna cuenta está asociada.",
      "REQUIRED_CHECKBOX": "Debe marcar esta casilla.",
      "REQUIRED_EMAIL": "Debe proporcionar una dirección de correo electrónico.",
      "REQUIRED_FIRST_NAME": "Debe proporcionar un nombre.",
      "REQUIRED_LAST_NAME": "Debe proporcionar un nombre.",
      "REQUIRED_PASSWORD": "Debe ingresar una contraseña.",
      "SHORT_PASSWORD": "La contraseña debe tener al menos {count} caracteres."
    },
    "FACEBOOK_LOAD_ERROR": "Parece que una extensión activada en su navegador nos está impidiendo usar la autenticación de Facebook. Por favor, desactiva la extensión si deseas utilizar esta función.",
    "FIRST_NAME_PLACEHOLDER": "Example: Juan",
    "FORGOT_PASSWORD": "¿Ha olvidado su contraseña?",
    "HAS_ACCOUNT": "¿Ya tienes una cuenta?",
    "HAS_SIGNED_IN": "Estás conectado a {spaceName}¡",
    "LAST_NAME_PLACEHOLDER": "Ejemplo: Dupont",
    "LOGIN": "Iniciar sesión",
    "NAME_PREVIEW": "Los demás usuarios te verán como:",
    "NO_ACCOUNT": "¿Todavía no tienes una cuenta?",
    "OAUTH_BUTTONS": {
      "CSAM": "Unirse con CSAM"
    },
    "PAGE_TITLE": "Iniciar sesión",
    "SIGNUP": "Crear una cuenta",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Ayúdenos a comprender mejor si la actividad de la plataforma es representativa de la población global. Esta información se utilizará únicamente con fines de verificación de la legitimidad de los participantes y estadísticas relacionadas con la participación.",
      "PAGE_TITLE": "Último paso!",
      "WELCOME_TOAST": "¡Felicidades, te has unido a {spaceName}!"
    },
    "UNLINK": "Cerrar sesión",
    "VERIFY_EMAIL": {
      "CONTENT": "Introduzca el código de verificación recibido en {email}.",
      "RESEND": "¿No has recibido un correo electrónico? {link}",
      "RESEND_LINK": "Reenviar el código",
      "RESEND_SUCCESS": "Se ha enviado un nuevo código de verificación.",
      "TITLE": "Verificar su cuenta",
      "VERIFY_ALERT": "Verifique su dirección de correo electrónico para participar en todas las consultas.",
      "VERIFY_SUCCESS": "Tu cuenta ha sido verificada correctamente."
    }
  },
  "BACK": "Anterior",
  "BUTTONS": {
    "ACCEPT": "Aceptar",
    "ACCESS_CONSULTATION": "Acceder a la consulta",
    "ACTIONS": "Acciones",
    "ADD": "Ajouter",
    "ADD_ATTACHMENTS": "Agregar archivos/ imágenes",
    "ADD_NEW_IDEA": "Contribuciones",
    "CANCEL": "Cancelar",
    "CHANGE_USER": "Cambiar de usuario",
    "CLEAR": "Borrar",
    "CLONE": "Dupliar",
    "CLOSE": "Cerrar",
    "COMMENT": "Comentar",
    "CONFIRM": "Confirmar",
    "CONTINUE": "Continuar",
    "DELETE": "Eliminar",
    "DELETE_VOTERS": "Eliminar votantes",
    "DRAG_DROP_ATTACHMENTS": "Arrastrar y soltar archivos/imagenes aquí o hacer clic",
    "EXPORT": "Exportador",
    "EXPORT_PARTICIPANTS": "Exportar participantes",
    "EXPORT_PROPOSALS": "Exportar las contribuciones",
    "EXPORT_RESULTS": "Exportar los resultados",
    "EXPORT_VOTERS": "Exportar los votantes",
    "FILTER": "Filtrar",
    "IGNORE": "Ahora no",
    "IMPORT": "Importar",
    "IMPORT_VIA_EXCEL": "Importar un archivo de Excel",
    "IMPORT_VIA_FORM": "Rellene el formulario en línea",
    "IMPORT_VOTERS": "Importar votantes",
    "IN_PROGRESS": "En progreso...",
    "JOIN": "Unirse",
    "LEARN_MORE": "En savoir plus",
    "NO": "No",
    "OPEN": "Abrir",
    "OPEN_IN_NEW_TAB": "Abrir una nueva pestaña",
    "PUBLISH": "Publique",
    "READ_MORE": "Ver más",
    "REJECT_ALL": "Rechazar todo",
    "SAVE": "Guardar",
    "SETTINGS": "Parámetros",
    "SKIP": "Pasar",
    "TRANSLATE_VIA_AI": "Traducir mediante IA",
    "UPDATE": "Modificar",
    "UPDATE_PICTURE": "Modificar",
    "UPLOAD_PICTURE": "Agregar una foto",
    "VERIFY": "Verificar",
    "VERIFY_EMAIL": "Verificar mi dirección de correo electrónico",
    "VIEW_ANSWER": "Ver respuesta",
    "VIEW_IDEAS": "Ver las contribuciones",
    "VOTE": {
      "BUDGET": "Apoyo",
      "NOT_SUPPORT": "No apoyo",
      "SUPPORT": "Apoyo",
      "TOAST": {
        "CANCEL": "Votre vote ha sido eliminado correctamente.",
        "SUCCESS": "Tu voto ha sido registrado correctamente"
      },
      "VOTE_AGAINST": "Voto en contra",
      "VOTE_FOR": "Yo voto por"
    },
    "WRITE": "Escribir"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Ningún contenido} one {{count} contenido} other {{count} contenidos}}",
  "COMMENTS": {
    "AUTHOR": "Autor",
    "CREATE": {
      "PRIVACY_WARNING": "Este contenido es confidencial. Solo el autor y la organización destinataria pueden verlo.",
      "SUBMIT": "Enviar"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Dejar un comentario público para explicar el cambio de estado"
      },
      "ERROR": "Debe completar correctamente los campos.",
      "PLACEHOLDER": "Tu comentario",
      "SUCCESS_ANOMALY": "Tu respuesta ha sido enviada.",
      "SUCCESS_DEMAND": "Su respuesta ha sido enviada.",
      "SUCCESS_IDEA": "Su comentario ha sido publicado.",
      "VALIDATE": "Validar"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "¡Sé el primero en comentar!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Este usuario está esperando tu respuesta desde el {date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "¡Sé el primero en comentar!",
      "CONTRIBUTION_ENDED": "La consulta ha terminado",
      "CONTRIBUTION_ENDED_ON": "La consulta finalizó el {date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "La consulta comienza el {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Ningún comentario} one {{count} Comentario} other {{count} Comentarios}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Ninguna respuesta} one {{count} Respuesta} other {{count} Respuestas}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Ningún comentario} one {{count} Comentario} other {{count} Comentarios}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Este comentario ha sido eliminado.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Ninguna respuesta} one {Ver {count} respuesta} other {Ver {count} respuestas}}",
      "REPLY": "Contestar"
    },
    "TITLE": "Comentarios"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "Un contraste suficiente garantiza un nivel de accesibilidad aceptable para tus usuarios. De acuerdo con las recomendaciones internacionales (WCAG) y las del Référentiel général d’amélioration de l’accessibilité (RGAA), te recomendamos elegir un color con un contraste de al menos {ratio}:1 (correspondiente al nivel AA del estándar WCAG versión 2.1)",
    "TEXT": {
      "BAD": "El nivel de contraste para este color es de {value}:1, lo que no cumple con las recomendaciones de accesibilidad (WCAG nivel AA).",
      "GOOD": "El nivel de contraste para este color es de {value}:1 y cumple con las recomendaciones de accesibilidad (nivel AA de WCAG)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} colocará cookies en su dispositivo si utiliza esta función."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "Ha activado un bloqueador de anuncios que impide la visualización de este vídeo. Desactívelo para continuar.",
      "CTA": "Aceptar las cookies",
      "VIMEO": "Vimeo desea almacenar cookies para mostrar el video",
      "YOUTUBE": "Youtube desea colocar cookies para mostrar el video"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Exportar las contribuciones",
        "MESSAGING": "Exportador",
        "PARTICIPATION": "Exportador"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Ninguna asignación} one {{count} Asignación} other {{count} Asignaciones}}",
      "COMMUNICATION": "{count, plural, =0 {Ninguna noticia} one {{count} Noticia} other {{count} Noticias}}",
      "CONSULTATION": "{count, plural, =0 {Ninguna consulta} one {{count} Consulta} other {{count} Consultas}}",
      "FOLDER": "{count, plural, =0 {Ningún archivo} one {{count} Archivo} other {{count} Archivos}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Ningún contenido} one {{count} Contenido} other {{count} Contenidos}}",
      "FORM_RESPONSES": "{count, plural, =0 {Ninguna respuesta} one {{count} Respuesta} other {{count} Respuestas}}",
      "INVITATIONS": "{count, plural, =0 {Ninguna invitación} one {{count} invitación} other {{count} invitaciones}}",
      "MESSAGING": "{count, plural, =0 {Ningún contenido} one {{count} Contenido} other {{count} Contenidos}}",
      "NEWSLETTERS": "{count, plural, =0 {Ninguna newsletter} one {{count} newsletter} other {{count} newsletters}}",
      "PARTICIPATION": "{count, plural, =0 {Ninguna contribución} one {{count} Contribución} other {{count} Contribuciones}}",
      "RANKING": "Clasificación de contribuciones",
      "USER": "{count, plural, =0 {Ningún usuario} one {{count} Usuario} other {{count} Usuarios}}",
      "VOTERS": "{count, plural, =0 {Ningún votante} one {{count} Votante} other {{count} Votantes}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Ninguna noticia seleccionada} one {{count} Noticia seleccionada} other {{count} Noticias seleccionadas}}",
      "CONSULTATION": "{count, plural, =0 {Ninguna consulta seleccionada} one {{count} consulta seleccionada} other {{count} consultas seleccionadas}}",
      "FOLDER": "{count, plural, =0 {Ningún archivo seleccionado} one {{count} Archivo seleccionado} other {{count} Archivos seleccionados}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Ningún contenido seleccionado} one {{count} contenido seleccionado} other {{count} contenidos seleccionados}}",
      "MESSAGING": "{count, plural, =0 {Ningún contenido seleccionado} one {{count} contenido seleccionado} other {{count} contenidos seleccionados}}",
      "PARTICIPATION": "{count, plural, =0 {No se ha seleccionado ninguna contribución} one {{count} Contribución seleccionada} other {{count} Contribuciones seleccionadas}}",
      "VOTERS": "{count, plural, =0 {Ningún votante seleccionado} one {{count} Votante seleccionado} other {{count} Votantes seleccionados}}"
    },
    "EDIT": "Modificar",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Aquí encontrarás el contenido que te ha sido asignado.",
      "COMMUNICATION": "Publique su primera noticia",
      "CONSULTATION": "Publica su primera consulta",
      "FOLDER": "Crea su primera carpeta",
      "FOLDER_CONTENT": "Aquí encontrarás el contenido de la carpeta.",
      "FORM_RESPONSES": "Aquí encontrarás las respuestas al cuestionario",
      "INVITATIONS": "Aquí encontrarás la lista de invitaciones.",
      "MESSAGING": "Aquí encontrarás los mensajes y las anomalías.",
      "NEWSLETTER": "Cree su primer boletin",
      "PARTICIPATION": "Aquí encontrarás las contribuciones de la consulta",
      "SEARCH": {
        "BUTTON": "Restablecer filtros",
        "DESCRIPTION": "Verifique que haya escrito correctamente su búsqueda o modifique los filtros.",
        "TITLE": "Ningún resultado"
      },
      "USER": "Aquí encontrarás la lista de usuarios registrados.",
      "VOTERS": "Encontrará aquí a los votantes de la consulta"
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Ciudad",
        "PLACEHOLDER": "Filtrar por ciudad"
      },
      "BLANK": "No especificado",
      "FOLDER": {
        "LABEL": "Carpeta",
        "PLACEHOLDER": "Filtrar por carpeta"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Borrador",
        "SCHEDULED": "Planificada",
        "SENT": "Envío"
      },
      "PROF_CATEGORY": {
        "LABEL": "Categoría socio-profesional",
        "PLACEHOLDER": "Filtrar por categoría socio-profesional"
      },
      "REGISTERED": {
        "LABEL": "Inscrito",
        "PLACEHOLDER": "Filtrar por inscripción",
        "REGISTERED": "Inscrito",
        "UNREGISTERED": "No inscrito"
      },
      "ROLES": {
        "ADMINISTRATOR": "Administrador",
        "AUTHOR": "Autor",
        "CITIZEN": "Usuario",
        "CONTRIBUTOR": "Gerente",
        "LABEL": "Papel",
        "PLACEHOLDER": "Filtrar por rol"
      },
      "SEX": {
        "LABEL": "Sexo",
        "PLACEHOLDER": "Filtrar por sexo"
      },
      "STATUS": {
        "ANSWERED": "No seleccionado",
        "DOING": "Análisis en curso",
        "DONE": "Concrétisada",
        "DUPLICATE": "Regroupada",
        "IN_PROGRESS": "Realización en curso",
        "LABEL": "Estatus",
        "MESSAGING": {
          "DOING": "Análisis en curso",
          "DONE": "Respuesta proporcionada",
          "LABEL": "Estado",
          "PLACEHOLDER": "Filtrar por estado",
          "TODO": "Depositada"
        },
        "PLACEHOLDER": "Filtrar por estado",
        "PLANNED": "Planificada",
        "REJECTED": "Rechazada",
        "SELECTED": "Retención",
        "TODO": "Deposited",
        "TO_MODERATE": "A moderar",
        "VALIDATED": "Ganador"
      },
      "TAG": {
        "LABEL": "Temática",
        "PLACEHOLDER": "Filtrar por temática"
      },
      "TYPES": {
        "ANOMALY": "Anomalía",
        "ARTICLE": "Artículo",
        "COLLABORATIVE_DECISION": "Concertación",
        "DEMAND": "Mensaje",
        "EVENT": "Evento",
        "FOLDER": "Carpeta",
        "IDEA": "Contribución",
        "IDEAS_REQUEST": "Llamada a contribuciones",
        "LABEL": "Tipo de contenido",
        "PARTICIPATORY_BUDGET": "Presupuesto participativo",
        "PLACEHOLDER": "Filtrar por tipo",
        "STUDY": "Cuestionario",
        "SURVEY": "Cuestionario"
      },
      "USER_TYPE": {
        "DESCRIPTION": "En línea o fuera de línea",
        "LABEL": "Participación",
        "OFFLINEUSER": "Desconectado",
        "PLACEHOLDER": "Filtrar por tipo de participación",
        "USER": "En línea"
      },
      "VISIBILITY": {
        "DRAFT": "No publicado",
        "LABEL": "Visibilidad",
        "PLACEHOLDER": "Filtrar por visibilidad",
        "PLANNED": "Planificado",
        "PUBLISHED": "Publicado"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "Los filtros se guardan para todos los administradores y gestores autorizados.",
      "NO_FILTERABLE_QUESTIONS": "No hay filtros disponibles.",
      "SECTION_TITLE_FORM": "Información del formulario",
      "SECTION_TITLE_PARTICIPANTS": "Perfil de los participantes",
      "TITLE": "Filtrar"
    },
    "MENU": {
      "ASSIGNMENT": "Asignaciones",
      "COMMUNICATION": "Noticias",
      "CONSULTATION": "Consultas",
      "FOLDER": "Archivos",
      "GENERAL": "General",
      "MESSAGING": "Mensaje",
      "NEWSLETTER": "Boletines",
      "PARTICIPATION": "Participación",
      "SETTINGS": "Parámetros",
      "SETTINGS_ACCESS": "Acceso",
      "SETTINGS_COMMUNICATION": "Comunicación",
      "SETTINGS_GENERAL": "General",
      "SETTINGS_LEGAL": "Textos legales",
      "SETTINGS_PAGES": "Páginas",
      "STATS": "Vista previa",
      "USER": "Usuarios"
    },
    "NEWSLETTERS": "Boletines",
    "PARTICIPATION": "Participación",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Activar",
        "APPLICATION_FILE_LABEL": "Importar una plantilla de archivo detallado de candidatura",
        "APPLICATION_FILE_TOOLTIP": "Para solicitar información adicional a los usuarios al presentar una nueva contribución, puede proporcionarles una plantilla de archivo detallada de solicitud.<br></br><b>Formatos aceptados:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "El formulario de envío corresponde a la información que el usuario deberá completar para enviar su contribución.",
        "REQUIRED": "Obligatorio",
        "TITLE": "Formulario de depósito"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Parámetros de noticias"
        },
        "CONSULTATION": {
          "TITLE": "Parámetros de la consulta"
        },
        "FOLDER": {
          "TITLE": "Parámetros de la carpeta"
        }
      },
      "TABS": {
        "ANALYSIS": "Análisis",
        "APPEARANCE": "General",
        "DISABLED_TOOLTIP": "Complete y guarde el formulario actual para acceder a este.",
        "IMPLEMENTATION": "Resultados",
        "MANAGERS": "Gestores",
        "PRESENTATION": "Presentación",
        "PUBLIC_FILTERS": "Filtros públicos",
        "QUESTIONS": "Preguntas",
        "SECURITY": "Seguridad",
        "SETTINGS": "Parámetros",
        "SUBMISSION": "Depósito",
        "VOTE": "Votar"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Añadir una búsqueda avanzada a su consulta para permitir que sus usuarios filtren las contribuciones en su página.",
      "TITLE": "Filtros públicos"
    },
    "SHOW": "Ver",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Primera página",
        "LAST_PAGE": "Última página",
        "NEXT_PAGE": "Página siguiente",
        "PREVIOUS_PAGE": "Página anterior"
      },
      "BUTTONS": {
        "ACTIONS": "Acciones",
        "CHANGE_STATUS": "Cambiar el estado",
        "DELETE": "Eliminar"
      },
      "PAGINATION": "{from}-{to} en {count}",
      "TITLES": {
        "ACTIONS": "Acciones",
        "ASSIGNED": "Responsable",
        "AUTHOR": "Autor",
        "BIRTHDATE": "Fecha de nacimiento",
        "BUDGET": "Cost",
        "COMMENTS_COUNT": "Comentarios",
        "COMMUNICATIONS_COUNT": "Noticias",
        "CONSULTATION": "Consulta",
        "CONSULTATIONS_COUNT": "Consultas",
        "CONSULTATION_TITLE": "Título de la consulta",
        "CONTRIBUTION": "Contribución",
        "CREATED_AT": "Fecha de invitación",
        "EMAIL": "Correo electrónico",
        "FIRST_NAME": "Nombre",
        "FOLDER": "Carpeta",
        "FOLDERS_COUNT": "Expédientes",
        "HAS_ACCESS": "¿Acceso?",
        "ID": "ID",
        "IDEAS_COUNT": "Contribuciones",
        "LAST_NAME": "Nombre",
        "LAST_VOTE_AT": "Fecha de votación",
        "NEWSLETTER_CREATED_AT": "Fecha de creación",
        "NEWSLETTER_SENT_AT": "Fecha de envío",
        "NEWSLETTER_SUBJECT": "Tema",
        "NEWSLETTER_TITLE": "boletín",
        "PARTICIPATION_TYPE": "Participación",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Publicado el",
        "RECIPIENTS": "Destinatarios",
        "RESPONSE_DATE": "Fecha",
        "ROLE": "Papel",
        "SENT_AT": "Fecha de envío",
        "SOURCE": "Participación",
        "STATE": "Estado",
        "STATUS": "Estatus",
        "SUBSCRIPTION_DATE": "Fecha de inscripción",
        "TITLE": "Título",
        "TOPIC": "Temática",
        "TYPE": "Escriba",
        "USER": "Usuario",
        "VISIBILITY": "Visibilidad",
        "VOTES_AGAINST_COUNT": "Votos en contra",
        "VOTES_COUNT": "Nombre de votos",
        "VOTES_FOR_COUNT": "Votos para"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {¡Último día!} one {Queda {count} día!} other {Quedan {count} días!}}",
    "INVALID_LABEL": "Invalido",
    "IN_N_DAYS": "Inicio {count}",
    "LABEL": {
      "DEFAULT": "Elige una fecha",
      "SCHEDULE_LABEL": "Publicar",
      "SCHEDULE_TITLE": "Planificar la publicación"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Contenido del correo electrónico",
        "PLACEHOLDER": "¡Hola, ...!"
      },
      "DELETED_USER_WARNING": "Este usuario ha solicitado eliminar su cuenta. Por lo tanto, no puedes contactarlo.",
      "SEND": "Enviar",
      "SUBJECT": {
        "LABEL": "Asunto del correo electrónico",
        "PLACEHOLDER": "Solicitud de información adicional sobre ..."
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Nota privada} one {{count} Nota privada} other {{count} Notas privadas}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Agregar una nota privada",
        "PUBLIC": "Su comentario"
      },
      "INFO": "Asegúrese de no escribir comentarios que contengan datos considerados sensibles.",
      "INFO_TOOLTIP": "Origen racial o étnico, opiniones políticas, filosóficas o religiosas, afiliación sindical, datos de salud, preferencia sexual, antecedentes penales, ...",
      "NO_COMMENTS": "Sé el primero en escribir una nota privada"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# contribuciones similares agrupadas con esta} one {{count} contribución similar agrupada con esta} other {{count} contribuciones similares agrupadas con esta}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Volver a la página principal",
    "CTA_NO_SPACE": "Encontrar un espacio de participación",
    "FORMER_CLIENT_TOAST": "El espacio que estás intentando visitar no existe o ya no está disponible.",
    "NOT_FOUND": {
      "DESCRIPTION": "Parece que te hemos llevado por el camino equivocado. ¿Empezamos de nuevo en buena dirección?",
      "TITLE": "Lo siento, no encontramos la página que estás buscando."
    },
    "OFFLINE": {
      "DESCRIPTION": "Parece que estás desconectado. ¿Comenzamos actualizando?",
      "TITLE": "Lo siento, no encontramos la página que estás buscando."
    },
    "RELOAD": "Recargar",
    "SERVER_ERROR": {
      "DESCRIPTION": "Esté seguro de que nuestros desarrolladores están trabajando para solucionarlo. Deberíamos estar de vuelta en poco tiempo.",
      "TITLE": "Ups, ocurrió un error inesperado."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Accesibilidad",
    "ETHICAL_POLICY": "Carta ética",
    "HELP": "Ayuda",
    "LEGAL_NOTICE": "Aviso legal",
    "PRIVACY_POLICY": "Política de privacidad",
    "TERMS_OF_USE": "Condiciones de uso"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "Debe completar correctamente los campos.",
      "REQUIRED": "Debe completar este campo."
    },
    "SELECT_EMPTY_LABEL": "No especificado",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Eliminación realizada exitosamente",
      "UPDATED_SUCCESSFULLY": "Actualización realizada con éxito"
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Respondido el <b>{date}</b> a las <b>{time}</b>",
    "SHOW_RESPONSE": "Ver mi respuesta",
    "SUBMISSION_NOT_ONGOING": "La consulta ha finalizado, ya no puedes responder o modificar tu respuesta.",
    "UPDATE_RESPONSE": "Modificar mi respuesta"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "¿Está seguro de que desea eliminar este elemento?",
    "CTA": "Sí, eliminar",
    "TITLE": "Eliminar"
  },
  "HOME": {
    "PAGE_TITLE": "Bienvenido a Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Ingresa el nombre del espacio",
    "SUBTITLE": "Encuentra un espacio para comenzar a participar"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Error al cargar la imagen",
    "LOADING": "Cargando imagen"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Para añadir varias contribuciones recibidas fuera de la plataforma, {link} sin modificar su formato.<br></br>Si no ha recopilado cierta información, por favor no elimine las columnas y déjelas vacías.<br></br>Si sus contribuciones están en varios idiomas, por favor traduzca todas al {defaultLang} antes de importarlas.",
        "LINK": "complete el modelo",
        "TITLE": "Importar contribuciones"
      },
      "STATUS": {
        "DESCRIPTION": "Indicar el estado de las contribuciones durante la importación",
        "TITLE": "Seleccionar el estado"
      }
    },
    "ERROR": {
      "DESCRIPTION": "No puedo importar tu archivo. Verifica que cumple con el modelo adecuado.",
      "EXPLANATION": "Verifique que no se haya eliminado ninguna columna y que las respuestas respeten el formato solicitado.",
      "ROWS_MULTIPLE": "No se puede importar su archivo. Se han identificado errores en las líneas {rows}.",
      "ROWS_SINGLE": "No se puede importar su archivo. Se ha identificado un error en la línea {rows}.",
      "ROWS_WITH_MORE": "No fue posible importar su archivo. Se identificaron errores en las líneas {rows} y {moreCount} más."
    },
    "FORM": {
      "CTA": "Importador",
      "UPLOAD_DATE": "{size} - Actualizado el {date}",
      "UPLOAD_TITLE": "Arrastrar el archivo o hacer clic"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Para añadir varias respuestas recibidas fuera de la plataforma, {link} sin modificar su formato.<br></br>Si no ha recopilado cierta información, por favor no elimine las columnas y déjelas vacías.<br></br>Si sus respuestas están en varios idiomas, por favor traduzca todas a {defaultLang} antes de importarlas.",
        "LINK": "complete el modelo",
        "TITLE": "Importar respuestas"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Verifique que la información de su importación coincida con las columnas del modelo.<br></br>Si la información no coincide, debe modificar su archivo y luego importar su archivo actualizado.",
      "TITLE": "Vérificar los datos"
    },
    "PROGRESS": "Importando...",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Para añadir votos recibidos fuera de la plataforma, {link} sin modificar su formato. Si no ha recopilado cierta información, por favor <b>no elimine las columnas</b> y déjelas en blanco.",
        "LINK": "complete la plantilla",
        "TITLE": "Importar votos"
      }
    }
  },
  "JOIN": "Unirse",
  "JOINED_SPACE": "Te has unido a {space}, ¡bienvenido!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Le mantendremos informado si se transmiten consultas relevantes para usted en el futuro. También puede encontrar otros espacios existentes utilizando la búsqueda a continuación y conectándose con su cuenta actual.",
      "CONTENT_NOT_FOUND": "Para volver a participar en una consulta, por favor, crea una cuenta nuevamente.",
      "TITLE": "Gracias por elegir mantener su cuenta activa.",
      "TITLE_NOT_FOUND": "Tu cuenta ya no existe o ya ha sido anonimizada."
    }
  },
  "LOADING_MORE": "Cargando…",
  "LOAD_MORE": "Ver más",
  "MENU_ITEMS": {
    "DESCRIPTION": "Personalizar las pestañas que aparecen en su barra de navegación.",
    "FORM": {
      "ADD_ITEM": "Añadir una pestaña",
      "ADD_SUBITEM": "Añadir una subpestaña",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Etiqueta",
          "PLACEHOLDER": "Indicar la etiqueta de su pestaña"
        },
        "LINK": {
          "LABEL": "Enlace externo",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Página por defecto",
          "PLACEHOLDER": "Seleccionar una página"
        },
        "POST": {
          "LABEL": "Contenido",
          "NO_OPTIONS": "No se encontró contenido",
          "PLACEHOLDER": "Buscar un contenido"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Noticias",
          "CONSULTATION": "Consultas",
          "FOLDER": "Dossier",
          "LABEL": "Tipo de contenido",
          "PLACEHOLDER": "Seleccionar un tipo de contenido"
        },
        "TYPE": {
          "LABEL": "Tipo",
          "PLACEHOLDER": "Seleccionar un tipo"
        }
      }
    },
    "GROUP": "Menú desplegable",
    "LINK": "Enlace externo",
    "NEW_GROUP": "NUEVO MENÚ DESPLEGABLE",
    "NEW_ITEM": "NUEVO ELEMENTO",
    "PAGE": "Página predeterminada",
    "PAGE_ABOUT": "Acerca de",
    "PAGE_CONSULTATIONS": "Consultas",
    "PAGE_NEWS": "Noticias",
    "PAGE_SEARCH": "Buscar",
    "POST": "Contenido",
    "TITLE": "Su barra de navegación"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Notificar una anomalía"
    },
    "DEMAND": {
      "REPORT_CTA": "Enviar un mensaje"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage es una solución de participación ciudadana que permite la toma de decisiones colectivas sobre temas de interés general.",
    "PAGES_TITLES": {
      "ABOUT": "Acerca de | {spaceName}",
      "CONSULTATIONS": "Consultas | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "Mis mensajes y anomalías | {spaceName}",
        "PROPOSALS": "Mis contribuciones | {spaceName}"
      },
      "DASHBOARD": "Panel de control | {spaceName}",
      "LEGAL_NOTICE": "Aviso legal | {spaceName}",
      "NEWS": "Actualidades | {spaceName}",
      "PRIVACY_POLICY": "Política de privacidad |{spaceName}",
      "SEARCH": "Búsqueda | {spaceName}",
      "SETTINGS": "Mi cuenta | {spaceName}",
      "TERMS_OF_USE": "Condiciones de uso | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName}: ¡descubre este artículo en Fluicity Engage!",
      "EVENT": "{cityName} : ¡participa en este evento!",
      "FOLDER": "{title} {url} vía",
      "IDEA": "Apoya esta contribución: {title} {url} vía"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{título}",
      "IDEA": "Apoye esta contribución: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "Puede modificar su contribución o enviarla tal cual. Los servicios evaluarán si su contribución puede ser publicada o no.",
      "REASON": "Razón:",
      "SUBMIT": "Enviar",
      "TITLE": "Tu contribución ha sido identificada como sospechosa."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD/MM/YYYY",
      "PLACEHOLDER": "DD/MM/AAAA"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Panel de control",
    "MY_ACCOUNT": "Mi cuenta",
    "MY_PROFILE": "Mi perfil"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Esta newsletter ya ha sido enviada",
    "CREATED_AT": "Creada el <b>{date}</b> a las <b>{time}</b>",
    "DRAFT": "Borrador",
    "FORM": {
      "CLEAR_SCHEDULING": "Cancelación de la planificación.",
      "CONTENT": {
        "LABEL": "Contenido",
        "PLACEHOLDER": "Contenido del email"
      },
      "RECIPIENTS": {
        "ALL": "Todos los usuarios",
        "LABEL": "Destinatarios",
        "PLACEHOLDER": "Seleccione los destinatarios"
      },
      "SAVE_SUCCESS": "Su boletín ha sido guardado exitosamente",
      "SCHEDULE": "Planificar el envío",
      "SCHEDULED_AT": "Fecha de envío",
      "SEND": "Enviar",
      "SEND_SUCCESS": "Su boletín ha sido enviado exitosamente.",
      "SEND_TEST": "Enviar la prueba",
      "SUBJECT": {
        "LABEL": "Tema",
        "PLACEHOLDER": "Asunto del correo electrónico"
      },
      "TEST_EMAIL": {
        "LABEL": "Direcciones de correo electrónico de prueba",
        "PLACEHOLDER": "Ingrese las direcciones de correo electrónico de prueba (separadas por comas)"
      },
      "TEST_SUCCESS": "Votre boletín de prueba ha sido enviado exitosamente."
    },
    "IMMEDIATELY": "Immediately",
    "NEW_NEWSLETTER": "Crear un boletín",
    "SCHEDULED": "Planificada",
    "SENT": "Enviada",
    "SENT_AT": "Enviado el <b>{date}</b> a las <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Modificar el boletín",
    "USERS_FILTER_COUNT": "{count, plural, =0 {No se encontraron destinatarios para esta selección} one {Se enviará su boletín a 1 persona} other {Se enviará su boletín a {count} personas}}"
  },
  "NEXT": "Suivant",
  "NONE": "Ninguno",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Consultas :<br />• Nuevas contribuciones<br />• Nuevas respuestas a encuestas<br />• Cuando un ciudadano responde a uno de mis comentarios<br />• Cuando una fase o consulta está por finalizar<br /><br />Mensajes :<br />• Nuevos mensajes<br />• Nuevas anomalías<br />• Cuando un ciudadano responde a uno de mis comentarios",
        "SUBTITLE": "diario",
        "TITLE": "Últimas actividades"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Modificación de una contribución por su autor<br />• Moderación de un contenido por el equipo de Fluicity Engage",
        "TITLE": "Otros"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Nueva consulta<br />• Inicio de una fase de ideación, votación o resultados",
        "TITLE": "Consultas"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Comentario o voto en mi contribución<br />• Respuesta a mi comentario<br />• Cambio de estado de mi contribución",
        "SUBTITLE": "diario",
        "TITLE": "Tus últimas actividades"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Boletines informativos sobre la actividad de la plataforma",
        "TITLE": "Boletines"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Eliminación de una contribución que has comentado<br />• Moderación de un contenido que has comentado",
        "TITLE": "Otros"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Nuevos artículos<br />• Nuevos eventos<br />• Contribuciones destacadas",
        "SUBTITLE": "semanal",
        "TITLE": "En este momento en el espacio"
      }
    },
    "INFO_BOX_TEXT": "Seleccione aquí las notificaciones por correo electrónico que desea recibir de la plataforma."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "¿Por qué?",
    "EXTREMELY_LIKELY": "Correcto",
    "NOT_LIKELY": "No hay problema",
    "TITLE": "Ayúdenos a mejorar Fluicity Engage",
    "VALUE_QUESTION": "¿Recomendarías Fluicity Engage a un compañero?"
  },
  "OFFLINE": "Desconectado",
  "ONLINE": "En línea",
  "OR": "O",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Ninguna contribución puede ser seleccionada",
    "TITLE": "Esta contribución se ha agrupado con la siguiente contribución similar"
  },
  "PAGE_OF": "Página {current} de {total}",
  "PASSWORD_RESET": {
    "ACTION": "actualizar",
    "ARIA_LABEL": "Mostrar contraseña",
    "PAGE_TITLE": "Crear una nueva contraseña",
    "TITLE": "Crear una nueva contraseña",
    "TOAST": "El nuevo contraseña ha sido guardado."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Volver a la página de inicio",
    "LINK_SENT": "Si una cuenta está asociada al correo electrónico <strong>{email}</strong>, recibirás un enlace para restablecerla. <br></br><br></br>Si no ves ningún correo, verifica en su carpeta de correo no deseado.",
    "PAGE_TITLE": "Reiniciar su contraseña",
    "RESET": "Restablecer",
    "SUB_TITLE": "¿Ha olvidado su contraseña? Le pasa a todo el mundo. Te enviaremos un correo electrónico con un enlace para restablecerla.",
    "TITLE": "Restablecer su contraseña"
  },
  "PICTURE_PICKER": {
    "COVER": "Elige una imagen para ilustrar su publicación"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "creado {date}",
      "MODAL": {
        "AFTER": "Después de la modificación",
        "BEFORE": "Antes de la modificación",
        "TITLE": "Histórico"
      },
      "NO_AUDITS": "Esta contribución aún no ha sido actualizada.",
      "UPDATE": "Actualizado {date}"
    },
    "AUTHOR": "Autor",
    "BUDGET": {
      "ALERT": "Debe <b>indicar el costo</b> de la contribución antes de definirla como \"Retenida\".",
      "BUDGET_VALUE": "Esta contribución cuesta <b>{budget}</b>",
      "MODAL_LABEL": "Costo de la contribución",
      "MODAL_TITLE": "Rellenar el costo",
      "NOT_ENOUGH_BUDGET": "El presupuesto restante es insuficiente.",
      "NOT_SELECTED": "Esta contribución no ha sido seleccionada para la fase de votación",
      "REMAINING_BUDGET": "Te quedan <strong>{remaining}</strong> para gastar."
    },
    "CARD": {
      "CONTRIBUTE": "Contribuir",
      "PARTICIPATE": "Participar",
      "READ_MORE": "Consultar",
      "VOTE": "Votante"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} voto} one {{progress} voto} other {{progress} votos}}",
        "TOOLTIP_2": "sobre {total, plural, =0 {una contribución} one {una contribución} other {contribuciones {total}}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Contribución",
          "TEXT_1": "O si tienes inspiración",
          "TEXT_2": "¿hacemos una contribución?"
        },
        "VOTE_CARD": {
          "CTA": "Votante",
          "TEXT_1": "Ya ha atravesado algunas proposiciones {emoji}",
          "TEXT_2": "¿Continuamos?",
          "TEXT_3": "o ver la lista completa"
        }
      }
    },
    "CLONE": {
      "ACTION": "Dupliar",
      "CANCEL": "No",
      "CONFIRM": "Sí, duplicar",
      "CONTENT_CLONED": "Este contenido ha sido duplicado correctamente.",
      "DESCRIPTION": "¿Realmente deseas duplicar este contenido?",
      "SUCCESS": "El contenido ha sido eliminado."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Comentario} one {Comentario} other {Comentarios}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "¡Sé el primero en participar!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} consulta} one {{count} consulta} other {{count} consultas}}",
      "ENDED_AT": "La consulta finalizó el {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Ninguna contribución} one {# contribución} other {# contribuciones} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Ninguna contribución localizada} one {1 contribución localizada} other {# contribuciones localizadas}}"
      },
      "MAP_TOOLTIP": "Las contribuciones no geolocalizadas no aparecen en el mapa. Una contribución puede tener múltiples ubicaciones.",
      "NEWS_COUNT": "{count, plural, =0 {noticias} one {{count} noticia} other {{count} noticias}}",
      "ONGOING_TEXT": "Acude aquí para participar.",
      "PARTICIPATE_OFF": "¡Visita aquí próximamente para contribuir a las contribuciones!",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Descubre los resultados",
        "PARTICIPATE": "Participe en la consulta"
      },
      "SEE_OWN_VOTES": "Ver solo mis votos",
      "STARTS_AT": "La consulta comienza el {date}",
      "STEP_ENDED_AT": "La fase \"{step}\" terminó el {date}",
      "STEP_STARTS_AT": "Cita el {date} para descubrir la fase “{step}”"
    },
    "CONTENT_DELETED_SUCCESSFULLY": "El contenido ha sido eliminado",
    "CREATE_MENU": {
      "ACTIONS": "Acciones",
      "ADDED_TO_FOLDER_TOAST": "Contenido añadido al archivo.",
      "ADD_TO_FOLDER": "Agregar a una carpeta",
      "ARTICLE": {
        "DESCRIPTION": "Presentar una noticia o una iniciativa"
      },
      "ASSIGN": "Asistente",
      "BUTTON": "Crear",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Implementar contribuciones co-construidas con los usuarios"
      },
      "CONTACT_AUTHOR": "Contactar al autor",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Crear una noticia",
        "CONSULTATION": "Crear una consulta"
      },
      "EDIT": "Modificar",
      "EVENT": {
        "DESCRIPTION": "Invitar a participar en una reunión"
      },
      "FOLDER": {
        "DESCRIPTION": "Agrupar alrededor de una problemática"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Recopilar contribuciones sobre sus desafíos estratégicos"
      },
      "MERGE": "Agrupar la contribución",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Asignar un presupuesto a contribuciones co-construidas con los usuarios"
      },
      "PIN": "Destacar",
      "REMOVED_FROM_FOLDER_TOAST": "Contenido eliminado de la carpeta.",
      "REPORT": "Reportar",
      "STEPS_COUNT": "{count, plural, one {# etapa} other {# etapas}}",
      "STUDY": {
        "DESCRIPTION": "Integrar una encuesta creada fuera de la plataforma",
        "TITLE": "Cuestionario - Integración"
      },
      "SURVEY": {
        "DESCRIPTION": "Interrogar a los usuarios sobre un tema específico y recopilar información detallada"
      },
      "UNPIN": "No poner en destacados",
      "UNPUBLISH": "Despublicar",
      "UPDATE_BUDGET": "Rellenar el presupuesto",
      "UPDATE_STATUS": "Cambiar el estado",
      "VIEW": "Ver publicación",
      "VIEW_IN_DASHBOARD": "Panel de control",
      "VIEW_POST": "Ver la publicación"
    },
    "DELETE": {
      "ACTION": "Eliminar",
      "CANCEL": "No",
      "CONFIRM": "Sí, eliminar",
      "CONTENT_DELETED": "Este contenido ha sido eliminado.",
      "DESCRIPTION": "¿Realmente desea eliminar este contenido?",
      "PLACEHOLDER": "Añade un comentario para detallar su eliminación.",
      "REASON": "Comentario",
      "SELECT_REASON": "Indique por qué está eliminando este contenido:",
      "SUCCESS": "Este contenido ha sido eliminado."
    },
    "DETAILS": {
      "AUTHORED_BY": "Portado por {name}",
      "DESCRIPTION_TITLE": "Descripción",
      "EVENT": {
        "ACCESS_THE_EVENT": "Acceder al evento",
        "EVENT_URL": "Visioconferencia",
        "STATE": {
          "FUTURE": "El evento comienza el <b>{date}</b> a las <b>{time}</b>.",
          "ONGOING": "El evento está en curso",
          "PAST": "El evento ha terminado"
        }
      },
      "MORE_TAGS": "{count, plural, one {y otro tema} other {y {count} otros temas}}",
      "STUDY": {
        "JOIN_BUTTON": "Unirse",
        "JOIN_DESCRIPTION": "Iniciar sesión o registrarse para acceder a la encuesta ¡",
        "PARTICIPATE": "Participar",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "La encuesta comienza el {date}.",
          "ENDED": "La investigación finalizó el {date}.",
          "ONGOING_ANSWERED": "Gracias por su participación, ha sido tenida en cuenta."
        },
        "SEE_RESULTS": "Ver resultados"
      },
      "UPDATE_MY_IDEA": "Modificar"
    },
    "EXPORT": {
      "BUTTON": "Exportar",
      "IDEAS": "Todas las contribuciones",
      "MESSAGES": "Todos los mensajes"
    },
    "FILTER_BY_IS_PINNED": "Destacado",
    "FILTER_BY_PUBLISHED": "Publicado",
    "FILTER_BY_STATUS": "Estado",
    "FILTER_BY_TAGS": "Temática",
    "FILTER_BY_TYPE": "Tipo de contenido",
    "FILTER_IS_PINNED_TRUE": "Sí",
    "FILTER_PUBLISHED_FALSE": "No publicado",
    "FILTER_PUBLISHED_TRUE": "Publicado",
    "FILTER_STATUS_ANSWERED": "No seleccionado",
    "FILTER_STATUS_DOING": "Análisis en curso",
    "FILTER_STATUS_DONE": "Concrétisada",
    "FILTER_STATUS_IN_PROGRESS": "En progreso",
    "FILTER_STATUS_SELECTED": "Retención",
    "FILTER_STATUS_TODO": "Déposada",
    "FILTER_STATUS_VALIDATED": "Ganador",
    "FILTER_TYPE_ANOMALY": "Anomalía",
    "FILTER_TYPE_ARTICLE": "Artículo",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Concertación",
    "FILTER_TYPE_DEMAND": "Mensaje",
    "FILTER_TYPE_EVENT": "Evento",
    "FILTER_TYPE_FOLDER": "Carpeta",
    "FILTER_TYPE_IDEA": "Contribución",
    "FILTER_TYPE_IDEAS_REQUEST": "Llamada a contribuciones",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Presupuesto participativo",
    "FILTER_TYPE_STUDY": "Cuestionario",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Abierto a contribuciones espontáneas"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Lugar",
        "PLACEHOLDER": "Agregar un lugar"
      },
      "CATEGORIES": {
        "LABEL": "Temáticas",
        "PLACEHOLDER": "Seleccione los temas de la consulta",
        "SELECT_ALL": "Todo seleccionar"
      },
      "CATEGORY": {
        "LABEL": "Temática",
        "PLACEHOLDER": "Selecciona un tema"
      },
      "CONTENT": "Descripción",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Añadir un archivo/imagen",
          "ADD_PICTURE": "Añadir una imagen",
          "DELETE_PICTURE": "Suprimir"
        },
        "ERRORS": {
          "FILE_SIZE": "El tamaño de la imagen no debe exceder {fileSize}Mo.",
          "FILE_TYPE": "La imagen debe estar en formato {fileTypes}."
        },
        "TOOLTIP": "<b>Tamaño recomendado:</b> {width} (ancho) por {height} píxeles (alto) <br></br> <b>Formatos aceptados:</b> .jpg, .jpeg, .png"
      },
      "PIN": "Este contenido está destacado.",
      "TITLE": "Título",
      "UNPIN": "Este contenido ya no está destacado."
    },
    "HOW_IT_WORKS": {
      "TITLE": "¿Cómo funciona?"
    },
    "INDICATORS": {
      "ATTENDEES": "Participantes",
      "COMMENTS": "Comentarios",
      "COMMUNICATIONS": "Noticias",
      "CONSULTATIONS": "Consultas",
      "IDEAS": "Contribuciones",
      "VOTES": "{online_count, plural, =0 {{online_count} voto en línea} one {{online_count} voto en línea} other {{online_count} votos en línea}} - {offline_count, plural, =0 {{offline_count} voto fuera de línea} one {{offline_count} voto fuera de línea} other {{offline_count} votos fuera de línea}}"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Continuar la conversación",
      "GIVE_YOUR_OPINION": "Déjanos su opinión"
    },
    "PREVIEW": "Ver en el sitio",
    "PUBLIC_STUDY": "Investigación pública",
    "PUBLISHED": "Publicado(a)",
    "PUBLISHED_AT": "Publicado el {date}",
    "PUBLISH_CANCELED": "La publicación de este contenido ha sido cancelada",
    "PUBLISH_EDIT": "Modificar la planificación",
    "PUBLISH_NOW": "Publicar ahora",
    "PUBLISH_NOW_TOASTER": "Tu contenido ahora es visible para los usuarios.",
    "PUBLISH_SCHEDULED": "Planificar la publicación",
    "REPORT": {
      "ACTION": "Reportar",
      "CODE_OF_ETHICS": "carta ética",
      "CONFIRM": "Enviar",
      "EMPTY_ERROR": "Debe completar correctamente los campos.",
      "FLUICITY_TERMS_PART_A": "Saber más sobre los",
      "FLUICITY_TERMS_PART_B": "y la",
      "FLUICITY_TERMS_PART_C": "de Fluicity Engage.",
      "PLACEHOLDER": "Añada un comentario para detallar su informe.",
      "SELECT_REASON": "Indique por qué estás informando este contenido:",
      "SUCCESS": "Gracias por esta notificación. Nos permite asegurar contenidos de calidad en Fluicity Engage.",
      "TERMS_OF_USE": "Condiciones Generales"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Respuesta} one {Respuesta} other {Respuestas}}",
    "SAVE": "Guardar",
    "SAVE_THE_DRAFT": "Guardar el borrador",
    "SCHEDULE": "Programador",
    "SCHEDULED": "Planificado(a)",
    "SCHEDULED_AT": "Planificado el {date}",
    "SCHEDULED_AT_TOASTER": "La publicación de este contenido está programada para el {date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Ver la concertación",
      "FOLDER": "Ver carpeta",
      "IDEA": "Ver la contribución",
      "IDEAS_REQUEST": "Ver la convocatoria de contribuciones",
      "PARTICIPATORY_BUDGET": "Ver el presupuesto participativo"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Desde <strong>{startAtDate} a {startAtHour}</strong> hasta <strong>{endAtDate} a {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Negro y blanco",
        "DOWNLOAD": "Descargar",
        "GENERATE": "Generar el código QR",
        "TITLE": "Código QR"
      },
      "SHARE_IT": "Compartir"
    },
    "SORT": {
      "BUTTON": "Ordenar",
      "POPULAR": "Popular",
      "RECENT": "Reciente"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Resumen de la participación"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {Cambiar el estado} one {Cambiar el estado} other {Cambiar el estado: {count} contribuciones seleccionadas}}",
      "MODAL": {
        "TITLE": "Avance de una contribución"
      },
      "ORIGINAL_POST": {
        "LABEL": "Título de la contribución original que se conservará",
        "TITLE": "Proporcionar el título de la contribución original a la que agrupar esta contribución:"
      },
      "POPOVER": {
        "BUTTON": "Más información"
      },
      "SUBMIT": "Guardar",
      "TITLE": "Estado",
      "UPDATED_SUCCESSFULLY": "El estado ha sido registrado."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Disponibles",
        "COMING": "Próximamente",
        "ENDED": "Finalizada",
        "ENDLESS": "En continuo",
        "ONGOING": "En curso"
      },
      "TABS": {
        "LABEL": "Pestañas de selección de fases de la publicación"
      }
    },
    "SUMMARY": {
      "TITLE": "Resumen de la contribution",
      "TOOLTIP": "Este resumen fue generado con la ayuda de inteligencia artificial para facilitar la lectura de la contribución."
    },
    "TAGS": {
      "PERIOD": "Del <strong>{startAtDate} a {startAtHour}</strong> al <strong>{endAtDate} a {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "El <strong>{startAtDate}</strong> de <strong>{startAtHour}</strong> a <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Del <strong>{startAtDate}</strong> al <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Anomalía",
      "ARTICLE": "Artículo",
      "COLLABORATIVE_DECISION": "Concertación",
      "DEMAND": "Mensaje",
      "EVENT": "Evento",
      "FOLDER": "Carpeta",
      "IDEA": "Contribution",
      "IDEAS_REQUEST": "Llamada a contribuciones",
      "PARTICIPATORY_BUDGET": "Presupuesto participativo",
      "STUDY": "Cuestionario",
      "SURVEY": "Cuestionario"
    },
    "UPDATED": "Le contenu ha sido actualizado exitosamente"
  },
  "POST_FORM": {
    "ACTION_SAVE": "Guardar",
    "ADMIN_UPDATE_ALERT": "Cuando modifiques una contribución, enviaremos automáticamente una notificación por correo electrónico a su autor. Para asegurarte de que el autor esté de acuerdo con tu modificación, te recomendamos que lo contactes directamente antes.",
    "APPLICATION_FILE": "Importe su archivo detallado de solicitud",
    "APPLICATION_FILE_BUTTON": "Agregar una carpeta",
    "APPLICATION_FILE_TOOLTIP": "Para enviar tu contribución, debes proporcionar obligatoriamente un archivo detallado de solicitud. Para ello, completa la plantilla proporcionada y envíala a continuación.<br></br><br></br>A diferencia de la información proporcionada en el resto del formulario (título, descripción, temática, etc.), que será pública, el contenido del archivo solo será accesible para los administradores de la plataforma.<br></br><br></br><b>Formatos aceptados:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Compartir documentos complementarios como imágenes o un video con su actualidad.",
        "CONSULTATION": "Compartir documentos adicionales como su reglamento, imágenes o un video en su consulta.",
        "FOLDER": "Compartir documentos complementarios como imágenes o un video en su expediente."
      },
      "TITLE": "Adjuntos"
    },
    "ATTACHMENTS_FILES": "Archivos",
    "ATTACHMENTS_IMAGES": "Imágenes",
    "ATTACHMENTS_TITLE": "Documentos",
    "AUTHORED_BY": "¿Quién es el autor?",
    "AUTHORED_BY_A_THIRD_PARTY": "Tercero",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "Una persona fuera de la plataforma",
    "AUTHORED_BY_CUSTOM": "Personalizado",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Asociación, grupo de ciudadanos, asamblea…",
    "AUTHORED_BY_FIRST_NAME": "Nombre del autor",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Ejemplo: Juan",
    "AUTHORED_BY_LAST_NAME": "Nombre del autor",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Ejemplo: Dupont",
    "AUTHORED_BY_MYSELF": "Yo mismo",
    "AUTHORED_BY_MY_SPACE": "Mi organización",
    "BUDGET": "Presupuesto estimado",
    "BUDGET_PLACEHOLDER": "Indica el presupuesto",
    "CHOOSE_A_FOLDER": "Seleccione una carpeta",
    "CONTENT": "Descripción",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Tipo de contribución",
      "CUSTOM_PLACEHOLDER": "Indicar el tipo de contribuciones que desea recolectar.",
      "DESCRIPTION": "Personalizar la etiqueta del botón (CTA) para enviar contribuciones.",
      "OPTIONS": {
        "CONTRIBUTION": "Contribución",
        "OTHER": "Otro",
        "PROPOSAL": "Proposición",
        "QUESTION": "Pregunta",
        "REPORT": "Denuncia"
      },
      "PREVIEW": "Vista previa:",
      "TITLE": "Tipo de contribución"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Para fomentar las reacciones (voto a favor o en contra)",
          "NAME": "Carrusel"
        },
        "LIST": {
          "DESCRIPTION": "Para una visualización compacta de todas las contribuciones",
          "NAME": "Lista"
        },
        "MAP": {
          "DESCRIPTION": "Para una visualización geográfica de las contribuciones",
          "NAME": "Tarjeta"
        }
      },
      "SUBTITLE": "Personalizar la página de su consulta seleccionando la vista predeterminada de las contribuciones. En cualquier caso, los usuarios podrán elegir una vista diferente.",
      "TITLE": "Visualización de las contribuciones"
    },
    "DESCRIPTION": "Descripción",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Esta sección le permite explicar a los usuarios el contexto y los desafíos de su actualidad.",
        "CONSULTATION": "Esta sección le permite explicar a los usuarios el contexto y los desafíos de su consulta.",
        "FOLDER": "Esta sección le permite explicar a los usuarios el contexto y los desafíos de su caso."
      },
      "TITLE": "Descripción del enfoque"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Mostrar las imágenes de las contribuciones en la lista",
        "TITLE": "Imagen"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Activar los comentarios en su encuesta"
      },
      "GEOJSON": {
        "DESCRIPTION": "Personalizar el mapa con áreas geográficas y puntos de interés en {link} luego pegar el código a continuación.",
        "TITLE": "Personalizar el mapa"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Modificar la anomalía",
        "COMMUNICATION": "Modificar la noticias",
        "CONSULTATION": "Modificar la consulta",
        "DEMAND": "Modifier le message",
        "FOLDER": "Modificar la carpeta",
        "IDEA": "Modificar la contribución"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Para dar acceso a un usuario, debe ser <i>Gerente</i> del espacio. Solo un <i>Administrador</i> puede asignar este rol.",
      "SUBTITLE": "La lista de usuarios que tienen acceso a la gestión de esta consulta.",
      "TITLE": "Administradores"
    },
    "END_AT": "Fecha y hora de finalización",
    "ERRORS": {
      "FILL_FIELDS": "Debe completar correctamente los campos.",
      "LOCATION_NOT_IN_THE_LIST": "Debe seleccionar una dirección de la lista."
    },
    "EVENT_URL_LABEL": "Videoconferencia",
    "EVENT_URL_PLACEHOLDER": "Añade la URL de una videoconferencia Zoom, Jitsi, Teams, Meet, etc.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Respuesta(s) permitida(s)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Validar la fecha proporcionada por el usuario con una fecha de referencia.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Seleccionar un operador",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Seleccionar cada respuesta posible.",
      "ACCEPTED_ANSWERS_SUMMARY": "Respuestas permitidas",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Separe cada respuesta permitida con un salto de línea.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Respuesta 1  \nRespuesta 2  \nRespuesta 3  \nRespuesta 4",
      "ADD_DESCRIPTION": "Añadir una descripción",
      "ADD_QUESTION": "Agregar una pregunta",
      "ADD_SECTION": "Añadir una sección",
      "CONFIDENTIAL": "Confidencial",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Su respuesta será visible solo para los administradores de la plataforma.",
      "CONFIDENTIAL_QUESTION": "Pregunta confidencial",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "La respuesta será visible solo para los administradores y gestores con los derechos correspondientes.",
      "DATE_OPERATOR": {
        "EQ": "este",
        "GT": "es superior a",
        "GTE": "es mayor o igual que",
        "LT": "es menor que",
        "LTE": "es menor o igual que",
        "NOT_EQ": "no es"
      },
      "DEFAULT_FIELD_INFO": "Por defecto",
      "DESCRIPTION_LABEL": "Descripción",
      "DESCRIPTION_PLACEHOLDER": "Esta pregunta nos permitirá conocerte mejor.",
      "DROPDOWN_QUESTION": "Liste desplegable",
      "DROPDOWN_QUESTION_DESCRIPTION": "Las opciones se mostrarán en un menú desplegable",
      "MAXLENGTH": "Limitar la cantidad de caracteres",
      "MAXLENGTH_DESCRIPTION": "Introduce el número máximo de caracteres permitidos",
      "MAXLENGTH_LABEL": "Número de caracteres",
      "MAXLENGTH_PLACEHOLDER": "Sin límite",
      "MAXLENGTH_SUMMARY": "Caracteres máx.",
      "OPTIONS": {
        "ADD_OPTION": "Agregar una opción",
        "ADD_OTHER": "Agregar \"Otro\"",
        "OR": "o",
        "OTHER": "Otro"
      },
      "OPTION_LABEL": "Opción {index}",
      "PLACEHOLDER": "Su respuesta",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Mostrar si la respuesta a ...",
        "OPERATOR": {
          "BLANK": "está vacío",
          "CONTAINS": "contiene",
          "EQ": "es",
          "GT": "es superior a",
          "GTE": "es mayor o igual que",
          "LT": "es inferior a",
          "LTE": "es menor o igual a",
          "NOT_CONTAINS": "no contiene",
          "NOT_EQ": "no es",
          "PRESENT": "no está vacío"
        },
        "OPERATOR_LABEL": "Operador",
        "OPTIONS_LABEL": "Opciones",
        "QUESTION_LABEL": "Pregunta",
        "TITLE": "Mostrando la pregunta"
      },
      "QUESTION_LINKS_SUMMARY": "Condición de visualización",
      "REQUIRED": "Obligatorio",
      "REQUIRED_QUESTION": "Pregunta obligatoria",
      "SUBMIT_FORM": "Unirse a la videoconferencia",
      "SURVEY_DESCRIPTION_1": "El cuestionario corresponde a las preguntas que desea hacer a sus usuarios.",
      "SURVEY_DESCRIPTION_2": "Configurar el cuestionario según su consulta.",
      "SURVEY_TITLE": "Cuestionario",
      "TITLE_LABEL": "Pregunta",
      "TITLE_PLACEHOLDER": "¿Cuál es tu edad?",
      "TYPES": {
        "ATTACHMENT": "Adjuntos",
        "CHECKBOX": "Respuestas múltiples",
        "DATE": "Fecha",
        "LOCATION": "Localización",
        "MONEY": "Presupuesto",
        "PHONE_NUMBER": "Número de teléfono",
        "PICTURE": "Imagen de portada",
        "RADIO": "Respuesta única",
        "SECTION": "Sección",
        "TEXT": "Respuesta corta",
        "TEXTAREA": "Párrafo",
        "TITLE": "Tipo de campo"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "Ya has recopilado respuestas para esta pregunta.",
        "DESCRIPTION_2": "Si lo modificas, las respuestas asociadas se eliminarán permanentemente.",
        "DESCRIPTION_3": "¿Necesitas estos datos? Exporta tus respuestas antes de eliminar estas preguntas y/o opciones.",
        "TITLE": "¿Estás seguro?"
      }
    },
    "GENERAL_INFO": "Informaciones generales",
    "IMAGE": "Imagen",
    "LOCALISATION_LABEL": "Lugar o dirección",
    "LOCALISATION_MARKER_PLACED": "Marca colocada",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Borrar",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Haz clic en el mapa para posicionar el marcador.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Validar",
    "LOCALISATION_MODAL_TITLE": "Añade una ubicación",
    "LOCALISATION_NO_RESULTS": "Por favor, escriba para obtener sugerencias",
    "LOCALISATION_PLACEHOLDER": "Añade una ubicación",
    "LOCALISATION_SEE_MAP": "Ver mapa",
    "MODERATABLE": {
      "LABEL": "Modération antes de publicación",
      "TOOLTIP": "Todas las contribuciones deberán ser validadas por un administrador para ser publicadas y visibles para otros usuarios."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Formule una descripción que especifique la anomalía encontrada y su naturaleza. Contextualícela para facilitar su tratamiento.",
        "MODAL_DESCRIPTION": "{spaceName} te responderá lo antes posible.",
        "MODAL_TITLE": "¡Felicidades, la anomalía ha sido enviada!",
        "SIDEBAR_ACTION": "Enviar",
        "SIDEBAR_DESCRIPTION": "La organización está a su disposición y responderá lo más pronto posible.",
        "TITLE": "Reportar una anomalía",
        "TITLE_PLACEHOLDER": "Quisiera informar..."
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Presente un tema actual o destaca una iniciativa, para informar regularmente sobre nuevas medidas y difundir información educativa.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios de este espacio. {isPrivateSpace, select, true {} other {Compártelo en las redes sociales para darle aún más visibilidad.}}",
        "MODAL_TITLE": "¡Felicidades, el artículo ha sido publicado!",
        "PROBLEMATIC_PLACEHOLDER": "Describe in one sentence your article to make people want to read it",
        "TITLE": "Crear un artículo",
        "TITLE_PLACEHOLDER": "Escriba un título que genere interés en los usuarios."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Proporcione detalles sobre el contexto de esta consulta. Explique los términos de participación para que los usuarios puedan participar de manera relevante en la búsqueda de soluciones.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Fíjalo a tu página de inicio y ponlo en portada para que sea aún más visible.",
        "MODAL_TITLE": "¡Felicidades, la consulta está publicada!",
        "PROBLEMATIC_PLACEHOLDER": "Anima a los usuarios a participar en una frase.",
        "SIDEBAR_ACTION": "Publicar",
        "TITLE": "Crear una concertación",
        "TITLE_PLACEHOLDER": "Escribe un título que genere interés en los usuarios."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Aclare el contexto del mensaje indicando cualquier elemento que permita comprender mejor su tema.",
        "MODAL_CTA": "Ver mis mensajes",
        "MODAL_DESCRIPTION": "El destinatario recibirá una notificación lo antes posible. En cualquier momento, puede encontrar este mensaje en el menú “Mis mensajes y anomalías” de su perfil.",
        "MODAL_TITLE": "¡Felicidades, el mensaje ha sido enviado!",
        "SIDEBAR_ACTION": "Enviar",
        "SIDEBAR_DESCRIPTION": "Este contenido es confidencial. Solo el usuario y los administradores pueden verlo.",
        "TITLE": "Enviar un mensaje",
        "TITLE_PLACEHOLDER": "Me gustaría obtener información sobre..."
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "Esta sección le permite a los usuarios especificar la fecha y ubicación (dirección y / o enlace a una videoconferencia) del evento.",
          "TITLE": "Modalidades de participación"
        },
        "DESCRIPTION_PLACEHOLDER": "Presenta el contexto del evento e informa a los usuarios sobre las condiciones para llegar allí.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Compártelo en las redes sociales para darle aún más visibilidad.",
        "MODAL_TITLE": "¡Felicidades, el evento ha sido publicado!",
        "PROBLEMATIC_PLACEHOLDER": "Describe en una frase tu evento para generar interés en leerlo",
        "SIDEBAR_ACTION": "Publicar",
        "TITLE_PLACEHOLDER": "Escriba un título que suscite el interés de los usuarios."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Proporcione detalles sobre el contexto de este archivo. Explique los términos de participación para que los usuarios puedan participar de manera relevante en la búsqueda de soluciones.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Fíjalo a tu página de inicio y ponlo en portada para que sea aún más visible.",
        "MODAL_TITLE": "¡Felicidades, el expediente ha sido publicado!",
        "PROBLEMATIC_PLACEHOLDER": "Agregar una frase inspiradora sobre su expediente.",
        "SIDEBAR_ACTION": "Publicar",
        "TITLE_PLACEHOLDER": "Escriba un título que genere interés en los usuarios."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Explique su contribución y cómo funciona.",
        "MODAL_CTA": "Voir mes contributions",
        "MODAL_DESCRIPTION": "Encuentra todas tus contribuciones en tu perfil.",
        "MODAL_DESCRIPTION_GUEST": "Para seguir su evolución y recibir actualizaciones, cree una cuenta. Sin registrarse, no podrá ver su impacto ni ser notificado(a) de los votos y comentarios.",
        "MODAL_TITLE": "Gracias por tu participación",
        "REDIRECT": "Este enlace parece no funcionar. Encuentre la consulta en la lista para poder contribuir.",
        "TITLE": "Completar el formulario",
        "TITLE_PLACEHOLDER": "Podríamos...",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "The translation for \"Publier\" is \"Publicar\".",
          "SIDEBAR_DESCRIPTION": "Una vez publicado, otros usuarios podrán enriquecer su contribución haciéndole sugerencias."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Soumettre",
          "SIDEBAR_DESCRIPTION": "La contribución se publicará una vez validada por los servicios."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Proporcione detalles sobre el contexto de esta convocatoria de contribuciones. Explique los términos de participación para que los usuarios puedan participar de manera relevante en la búsqueda de soluciones.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Fíjalo a tu página de inicio y ponlo en portada para que sea aún más visible.",
        "MODAL_TITLE": "¡Felicidades, la convocatoria de contribuciones ha sido publicada!",
        "PROBLEMATIC_PLACEHOLDER": "Anima a los usuarios a participar en una frase.",
        "SIDEBAR_ACTION": "Publicar",
        "TITLE_PLACEHOLDER": "Escriba un título que genere interés en los usuarios."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Proporcione detalles sobre el contexto de este presupuesto participativo. Explique los términos de participación para que los usuarios puedan participar de manera relevante en la búsqueda de soluciones.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Fíjalo a tu página de inicio y ponlo en portada para que sea aún más visible.",
        "MODAL_TITLE": "¡Felicidades, el presupuesto participativo está publicado!",
        "PROBLEMATIC_PLACEHOLDER": "Da ganas a los usuarios de participar en una frase.",
        "SIDEBAR_ACTION": "Publicar",
        "TITLE_PLACEHOLDER": "Escriba un título que suscite el interés de los usuarios."
      },
      "STUDIES": {
        "DESCRIPTION": "La encuesta corresponde al formulario creado fuera de la plataforma en Typeform, Google Form, Survey Monkey, Tally u otras plataformas que permiten crear formularios.",
        "DESCRIPTION_PLACEHOLDER": "Proporciona detalles sobre el contexto de esta consulta y sus modalidades de participación.",
        "FORM_DESCRIPTION": "Agregar los enlaces de su encuesta para compartirlos en su plataforma.",
        "MODAL_DESCRIPTION": "Ahora es visible para otros usuarios. Comparte en redes sociales para darle aún más visibilidad.",
        "MODAL_TITLE": "¡Felicidades, la encuesta ha sido publicada!",
        "PROBLEMATIC_PLACEHOLDER": "Dale a los usuarios ganas de participar en una frase.",
        "SIDEBAR_ACTION": "Publicar",
        "STUDY_ID_PLACEHOLDER": "Ejemplo: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Ejemplo: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Link de resultados",
        "STUDY_TITLE": "Link de la encuesta",
        "TITLE_PLACEHOLDER": "Escriba un título que genere interés en los usuarios."
      },
      "TITLE": {
        "ANOMALY": "Crear una anomalía",
        "COMMUNICATION": "Crear una noticia",
        "CONSULTATION": "Crear una consulta",
        "DEMAND": "Crear un mensaje",
        "FOLDER": "Crear una carpeta",
        "IDEA": "Crear una contribución"
      }
    },
    "POST_PUBLISHED": "Este contenido está ahora publicado.",
    "POST_PUBLISHED_AT": "Publicado el {date} a las {time}",
    "POST_SAVED": "Las modificaciones han sido guardadas.",
    "POST_SCHEDULED": "Este contenido está programado para el {date} a las {time}",
    "PROBLEMATIC": "Enganche",
    "PUBLICATION_CANCELLED": "La publicación ha sido cancelada correctamente.",
    "SIMILAR_PROPOSALS": "Otros usuarios parecen haber compartido contribuciones similares:",
    "START_AT": "Fecha y hora de inicio",
    "STEPS": {
      "CONFIGURATION": "Configuración de la fase",
      "DESCRIPTION": "Esta sección te permite comunicar a los usuarios las fechas clave de la consulta.",
      "DESCRIPTION_TABS": "Pestañas de la descripción multilingüe de la fase",
      "END_AT_HELPER_TEXT": "Opcional para las etapas continuas",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Recuerda agregar el \"Enlace de resultados\" y verificar la configuración para activar la opción.",
        "ADMIN_ONLY_TEXT": "Mostrar los resultados de la consulta",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "El informe completo presenta todos los resultados de la encuesta, pregunta por pregunta. Es un elemento importante de transparencia hacia los usuarios.",
          "ADMIN_ONLY_TEXT": "Mostrar los resultados de la consulta"
        }
      },
      "PLACEHOLDER": "Explica el desarrollo de este paso.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Todos los usuarios pueden publicar contribuciones en la consulta. Si la opción está desactivada, solo los administradores podrán crear nuevas contribuciones.",
        "ADMIN_ONLY_TEXT": "Dépósito abierto a los usuarios"
      },
      "TITLE": "Configuración del despliegue"
    },
    "TITLE": "Título",
    "UNDERSTOOD": "¡Entendido!",
    "VIDEO": "Vídeo",
    "VIDEO_HELPER": "Sólo puedes compartir un vídeo de Youtube o Vimeo.",
    "VIDEO_LABEL": "Link to a video",
    "VIDEO_PLACEHOLDER": "Exemple: http://www.youtube.com/watch?=id ou http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Restringir los votos (Para) al presupuesto de {count} previamente definido",
        "TITLE": "Restriction presupuestaria"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Número máximo de votos",
        "MIN_LABEL": "Número mínimo de votos",
        "TITLE": "Número de apoyos asignados"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Los usuarios podrán apoyar las contribuciones hasta agotar el total del presupuesto. Las contribuciones deben estar presupuestadas.",
          "NAME": "Por sobre"
        },
        "DOUBLE": {
          "DESCRIPTION": "Los usuarios podrán apoyar las contribuciones de manera positiva o negativa. Se utiliza frecuentemente en casos de convocatorias de contribuciones o reacciones.",
          "NAME": "A favor o en contra"
        },
        "SINGLE": {
          "DESCRIPTION": "Los usuarios solo podrán apoyar las contribuciones de manera positiva. Este módulo se utiliza a menudo si su consulta incluye una fase de votación.",
          "NAME": "Para"
        },
        "SUBTITLE_1": "Las opciones de voto permiten a los usuarios apoyar las contribuciones realizadas en su consulta.",
        "SUBTITLE_2": "Configurar los términos según su proyecto",
        "TITLE": "Modalidades de votación"
      },
      "UNLIMITED": "Ilimitado"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Análisis",
      "CONTRIBUTION": "Contribución",
      "IMPLEMENTATION": "Resultados",
      "SUBMISSION": "Depósito",
      "VOTE": "Votar"
    },
    "STUDY": {
      "IMPLEMENTATION": "Resultados",
      "SUBMISSION": "Respuesta"
    }
  },
  "PREVIOUS": "Anterior",
  "PROFILE": {
    "ADDRESS": "Comuna",
    "BIRTHDATE": "Fecha de nacimiento",
    "CROSS_SPACES_WARNING": "Las informaciones a continuación se refieren a todos los espacios a los que te has unido.",
    "FIRST_NAME": "Nombre",
    "LAST_NAME": "Nombre",
    "NAME_IS_PRIVATE": "Los demás usuarios te verán como: {displayName}",
    "NATIONAL_ID": "Número de registro nacional",
    "PRIVATE_INFORMATION_NOTICE": "Estas informaciones serán utilizadas únicamente con fines estadísticos relacionados con la participación.",
    "PROFILE_UPDATED": "Perfil actualizado.",
    "SEX": "Género",
    "SEX_FEMALE": "Mujer",
    "SEX_HELPER": "Como se indica en su documento nacional de identidad. Una vez agregados, estos datos se comparan con las estadísticas proporcionadas por institutos nacionales o por la propia organización.",
    "SEX_MALE": "Hombre",
    "SEX_UNSPECIFIED": "No especificado",
    "SOCIOPROFESSIONAL_CATEGORY": "Categoría socio-profesional",
    "TITLE": "Cuenta mía"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Antes de poder publicar este contenido, debes {link} al formulario",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "agregar preguntas",
    "PARENT_WARNING": "Antes de poder publicar este contenido, debe publicar {link}.",
    "PUBLISH": {
      "BUTTON": "Publicar ahora",
      "CONTENT": "¿Realmente deseas publicar?",
      "NO": "No",
      "TOAST": "Este contenido ha sido publicado.",
      "YES": "Sí, publicar"
    },
    "SCHEDULE": {
      "BUTTON": "Planificar la publicación",
      "CONTENT": "¿Realmente deseas planificar?",
      "NO": "No",
      "TOAST": "Este contenido ha sido planificado.",
      "YES": "Sí, planificar"
    },
    "UNPUBLISH": {
      "BUTTON": "Despublicar",
      "CHILDREN_WARNING": "Al despublicar este contenido, también se despublicará todo lo que contiene ({childrenCount}).",
      "CONTENT": "¿Realmente desea despublicar?",
      "NO": "No",
      "TOAST": "Este contenido ha sido despublicado.",
      "YES": "Sí, despublicar"
    },
    "UNSCHEDULE": {
      "BUTTON": "Cancelar la programación",
      "CONTENT": "¿Realmente desea cancelar la programación?",
      "NO": "No",
      "TOAST": "La planificación de este contenido ha sido cancelada.",
      "YES": "Sí, cancelar la planificación"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Ninguna respuesta} one {{count} respuesta} other {{count} respuestas}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Búsqueda",
    "CATEGORIES_PLACEHOLDER": "Filtrar por tema",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Comienza a escribir palabras clave en la barra de búsqueda.",
      "NO_RESULTS": "Comprueba que hayas escrito todo correctamente. También puede intentar acortar o reformular su búsqueda."
    },
    "INPUT_PLACEHOLDER": "Búsqueda",
    "RESULTS_COUNT": "{count, plural, =0 {Ningún resultado} one {{count} resultado} other {{count} resultados}}",
    "TYPES_PLACEHOLDER": "Filtrar por tipo de contenido"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Volver a la consulta",
    "BIRTHDATE": {
      "TITLE": "Fecha de nacimiento"
    },
    "CSAM": {
      "TITLE": "Conexión a través de CSAM"
    },
    "CTA": "Participar",
    "DESCRIPTION": "<b>Esta consulta está asegurada.</b> Para acceder a ella, debe validar los datos listados a continuación y completar los que faltan.<conditional> En cualquier momento, puede ejercer sus derechos de acceso, rectificación y eliminación de estos datos contactando a dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Desafortunadamente, la información que has proporcionado no te permite participar en la consulta. Corrige tus datos o regresa a la consulta.",
      "TITLE": "Dimensiones"
    },
    "INLINE_DESCRIPTION": "<b>Esta consulta es segura.</b> Para acceder a ella, debe proporcionar los datos necesarios. En cualquier momento, puede ejercer sus derechos de acceso, rectificación y eliminación de estos datos a través de la página de su perfil si tiene una cuenta o por correo electrónico a través de dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "Debe ingresar un número de registro válido que contenga 11 dígitos.",
      "TITLE": "Número de registro nacional"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Su participación se tendrá en cuenta <b>después de verificar sus documentos</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Verso (solo para nueva tarjeta de identidad)",
      "FORM": {
        "DESCRIPTION": "Por favor, proporcione el anverso y el reverso de su documento de identidad (formato JPEG, JPG, PNG, HEIC, WEBP o PDF, tamaño máximo recomendado 2MB).<br></br>Solo se aceptan los siguientes documentos:<ul><li>Cédula de identidad</li><li>Pasaporte francés</li><li>Permiso de conducir (nuevo formato de tarjeta de crédito)</li></ul>",
        "GENERIC_ERROR": "Ha ocurrido un error durante la descarga de sus documentos. Por favor, verifique el estado de su conexión o intente nuevamente más tarde. También puede intentar reducir el tamaño del documento (tamaño máximo recomendado 2MB).",
        "SUCCESS_TOAST": "Su identidad ha sido verificada exitosamente."
      },
      "FRONT": "Recto",
      "NO": "No",
      "TITLE": "Documento de identidad",
      "YES": "Sí"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Solo se aceptan: <ul><li>Factura reciente de electricidad, gas o agua</li><li>Factura de teléfono fijo o móvil</li><li>Recibo de sueldo</li><li>Certificado de seguro de vivienda (incendio, riesgos locativos o responsabilidad civil)</li><li>Tarjeta electoral</li><li>Aviso de impuesto</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "Debe validar primero su identificación para enviar su comprobante de domicilio.",
      "DESCRIPTION": "Por favor, proporcione un comprobante de domicilio (formato JPEG, JPG, PNG, HEIC, WEBP o PDF, tamaño máximo recomendado 2MB).",
      "DOCUMENT_CONFIRMATION": "Después de la verificación por parte de nuestros equipos, se le enviará un correo electrónico para confirmar su participación.",
      "TITLE": "Justificante de domicilio"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Este valor es incorrecto."
    },
    "SIGNUP_INVITATION": "Si desea <b>recibir un correo electrónico de confirmación</b> de su participación y guardar sus documentos, por favor cree una cuenta.",
    "SUCCESS": "Puedes participar ahora en la consulta.",
    "TOOLTIP": "Esta consulta es segura y requiere cierta información para participar.",
    "VALIDATED_INLINE_DESCRIPTION": "Hemos validado su identidad como <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Verificación de cuenta"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Mostrar las preguntas de seguridad",
    "FORM_BUILDER": {
      "DESCRIPTION": "Las preguntas de seguridad son mecanismos de control de acceso.<br></br> Permiten verificar que los participantes cumplan con ciertas condiciones antes de contribuir, votar, comentar o responder a una encuesta (por ejemplo: código de acceso, ID nacional, residente de un territorio, etc.).",
      "TITLE": "Preguntas de seguridad"
    },
    "OPTION_1": {
      "DESCRIPTION": "No es necesario registrarse para participar",
      "TITLE": "Todo el mundo"
    },
    "OPTION_2": {
      "DESCRIPTION": "Los usuarios deben registrarse para participar",
      "TITLE": "Registrados"
    },
    "OPTION_3": {
      "DESCRIPTION": "Los usuarios deben verificar su cuenta para participar.",
      "TITLE": "Inscritos verificados"
    },
    "OPTION_4": {
      "DESCRIPTION": "El depósito está cerrado para los usuarios.",
      "TITLE": "Administradores"
    },
    "WHO_CAN_COMMENT": "¿Quién puede comentar?",
    "WHO_CAN_RESPOND_SURVEY": "¿Quién puede responder a la encuesta?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "¿Quién puede presentar una contribución?",
    "WHO_CAN_VOTE": "¿Quién puede votar?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Parámetros de conexión",
      "DATA_SHARED_WITH_SPACE": "Mis datos",
      "LANGUAGE": "Idioma",
      "PASSWORD": "Contraseña (mínimo 12 caracteres)",
      "VERIFIED": "Verificado",
      "VERIFIED_EMAIL": "E-mail verificado"
    },
    "COOKIES": {
      "DESCRIPTION": "Las siguientes cookies \"funcionales\" activan características específicas y opcionales en Fluicity Engage para mejorar su experiencia de usuario.",
      "FACEBOOK": {
        "DESCRIPTION": "Te permite iniciar sesión en su espacio de participación utilizando su cuenta de Facebook.",
        "TITLE": "Facebook Conectar"
      },
      "GOOGLE": {
        "DESCRIPTION": "Te permite iniciar sesión en su espacio de participación con su cuenta de Google.",
        "TITLE": "Inicio de sesión con Google"
      },
      "TITLE": "Mis preferencias de cookies",
      "VIMEO": {
        "DESCRIPTION": "Te permite ver los videos alojados en Vimeo directamente desde su espacio de participación.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Te permite ver los videos alojados en Youtube directamente desde su espacio de participación.",
        "TITLE": "Youtube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Sí, eliminar mi cuenta",
      "CTA": "Eliminar mi cuenta",
      "TITLE": "¿Estás seguro de que quieres eliminar su cuenta de Fluicity Engage?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Para darte de baja o volver a suscribirte a uno o varios tipos de notificaciones, puedes modificar tus ajustes a continuación. Estos ajustes también se pueden acceder en cualquier momento desde la configuración de su cuenta.",
        "SUCCESS_TITLE": "Se ha registrado correctamente su solicitud de cancelación de suscripción."
      }
    },
    "JOIN_SPACE": "Unirse a {spaceName}",
    "LANGUAGE": {
      "LABEL": "Idioma"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Sí, abandonar el espacio",
      "CTA": "Salir {spaceName}",
      "DESCRIPTION": "Al abandonar este espacio, ya no recibirá notificaciones relacionadas con consultas o noticias y no podrá realizar nuevas contribuciones, comentar, votar, etc.",
      "TITLE": "¿Estás seguro de que quieres salir de {spaceName}?"
    },
    "NO_SPACES": "No sigues ningún espacio.",
    "PASSWORD": {
      "CONFIRMATION": "Confirmación de contraseña",
      "CREATE": "Crear",
      "CREATE_INPUT": "Crear una contraseña",
      "CREATE_MESSAGE": "No se ha configurado una contraseña todavía",
      "CURRENT": "Contraseña actual",
      "DIALOG": {
        "CREATE_TITLE": "Crear una contraseña",
        "SUBTITLE_2": "Por favor ingrese su contraseña actual y su nueva contraseña:",
        "TITLE": "Cambiar mi contraseña",
        "VALIDATE": "Validar"
      },
      "ERROR_LOGIN": "Error de conexión.",
      "FORGOT_PASSWORD": "¿Ha olvidado su contraseña?",
      "NEW": "Nuevo contraseña",
      "PLACEHOLDER": "Contraseña",
      "SHORT_PASSWORD": "La longitud de la contraseña no puede ser inferior a {length} caracteres.",
      "SUCCESS": "La nueva contraseña ha sido guardada.",
      "UPDATE": "Modificar",
      "WRONG_PASSWORD": "La contraseña debe tener al menos 8 caracteres."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Hacer una solicitud de portabilidad de mis datos personales",
        "EMAIL_BODY": "Hola,\n\nDe acuerdo con la Política de Privacidad de Datos de la solución Fluicity Engage, me gustaría solicitar una exportación de todos los datos personales relacionados conmigo que se encuentran alojados en la plataforma.\n\nMi correo electrónico de identificación en la plataforma es: {userEmail}\n\nGracias de antemano,\n\n{userName}",
        "EMAIL_SUBJECT": "Demanda de portabilidad de mis datos"
      },
      "TITLE": "Privacidad y datos personales"
    },
    "REQUIRED_DIMENSION_INFO": "Algunas informaciones son requeridas para la participación en este espacio. Para ejercer sus derechos de borrado, simplemente salga del espacio.",
    "SPACE_SELECTION": "Selección de espacio",
    "TABS": {
      "INFO": "Mis información",
      "MY_SPACE": "Mi espacio",
      "NOTIFICATIONS": "Mis notificaciones",
      "SETTINGS": "Mis ajustes"
    }
  },
  "SIGN_IN": "Unirse",
  "SIGN_OUT": "Desconexión",
  "SIGN_UP": {
    "EMAIL": "Correo electrónico",
    "LOCATION_LABEL": "Municipio de residencia",
    "LOCATION_PLACEHOLDER": "Lima",
    "PRIVACY": "Política de Privacidad",
    "TERMS": "Condiciones de uso"
  },
  "SORT": {
    "COMMENTED": "Las más comentadas",
    "LEAST_EXPENSIVE": "Menos costosas",
    "POPULAR": "Popular",
    "RANDOM": "Aleatorio",
    "RECENT": "Las más recientes",
    "UPVOTED": "Más votadas"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {consulta iniciada} one {consulta iniciada} other {consultas iniciadas}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {contribución concretada} one {contribución concretada} other {contribuciones concretadas}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {participación} one {participación} other {participaciones}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {inscrito} one {inscrito} other {inscritos}}"
      },
      "TITLE": "General"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Aquí encontrarás los expedientes, convocatorias de contribuciones, presupuestos participativos y encuestas publicadas por la organización.",
      "TITLE": "{count, plural, =0 {Ninguna consulta} one {{count} consulta} other {{count} consultas}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "Aquí encontrarás tus mensajes y anomalías.",
        "TITLE": "Mis mensajes y anomalías"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Aquí encontrarás sus contribuciones.",
        "TITLE": "Mis contribuciones"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Dirección",
      "ADDRESS_PLACEHOLDER": "Busque una dirección",
      "ADMINISTRATORS": "Administradores",
      "BRAND_LOGO_LABEL": "Logotipo de su espacio",
      "BRAND_LOGO_TOOLTIP": "El logotipo del espacio se mostrará en la parte superior izquierda de la página en la barra de navegación y en los correos electrónicos.",
      "COLOR_LABEL": "Color",
      "COLOR_PLACEHOLDER": "Color",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Nombre del patrocinador",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Por favor ingrese el nombre",
      "DECISION_MAKER_LAST_NAME_LABEL": "Patrocinador",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Introduzca el nombre",
      "DECISION_MAKER_PICTURE_LABEL": "Imagen de perfil del patrocinador",
      "DECISION_MAKER_ROLE_LABEL": "Rol del patrocinador",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Especifique la misión del patrocinador en su organización",
      "DESCRIPTION_HELPER": "La etiqueta meta descripción permite a los motores de búsqueda tener una vista previa del contenido de las páginas mostradas durante una búsqueda.",
      "DESCRIPTION_LABEL": "Descripción meta",
      "DESCRIPTION_PLACEHOLDER": "Redacta un texto breve y atractivo",
      "EMAIL_LABEL": "Correo electrónico",
      "EMAIL_PLACEHOLDER": "correo@miweb.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mi-pagina",
      "FAVICON_LABEL": "Icono de página (Favicon)",
      "FAVICON_TOOLTIP": "El favicon es el icono que aparece en las pestañas del navegador para identificar más fácilmente su sitio.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mi-pagina",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Dirección: 210 avenida Jean Jaurès, 69007 Lyon, Francia",
        "COMPANY_EMAIL": "Correo electrónico: info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Teléfono: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Sitio alojado por: Amazon Web Services (AWS) en París, Francia.",
        "HOSTING": "Alojamiento",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Alojamiento y solución técnica",
        "HOST_ADDRESS": "Dirección del anfitrión: 38 avenida John F. Kennedy, L-1855 Luxemburgo",
        "PLATFORM_HOSTED_BY": "Mis disculpas, parece que el texto ya está en español. Permíteme corregirlo:\n\nLa plataforma está alojada y potenciada por Fluicity Engage, una solución publicada por la empresa Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage actúa como tercero de confianza para la recolección y el procesamiento de datos, cumpliendo con el RGPD."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mi-pagina",
      "LOCALES": "Idiomas",
      "LOCALES_HELPER": "Seleccione los idiomas en los que los usuarios podrán navegar en su plataforma.",
      "LOCALES_LABEL": "Idiomas disponibles",
      "LOCALE_DEFAULT_HELPER": "Seleccione el idioma predeterminado de su plataforma.",
      "LOCALE_DEFAULT_LABEL": "Idioma predeterminado",
      "LOGO_PICTURE_LABEL": "Imagen de perfil de los administradores",
      "LOGO_PICTURE_TOOLTIP": "Cuando crean una consulta, una contribución, un mensaje o comentan en la plataforma, los administradores serán identificados por esta imagen de perfil y el nombre del espacio en lugar de su propia imagen y nombre.",
      "NAME_HELPER": "El nombre del espacio se mostrará en muchos lugares: en el nombre de las páginas, en los correos electrónicos, en lugar del nombre de los administradores, etc.",
      "NAME_LABEL": "Nombre del espacio",
      "NAME_PLACEHOLDER": "Establezca el nombre de su espacio",
      "PHONE_LABEL": "Teléfono",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Color principal",
      "PRIMARY_COLOR_PLACEHOLDER": "Color principal",
      "SECONDARY_COLOR_LABEL": "Color secundario",
      "SECONDARY_COLOR_PLACEHOLDER": "Color secundario",
      "SPACE_DECISION_MAKER": "Patrocinador",
      "SPACE_DECISION_MAKER_TOOLTIP": "El patrocinador es una personalidad de su organización que motivará, tranquilizará y comprometerá a sus usuarios.",
      "SPACE_LEGAL_NOTICE": "Aviso legal",
      "SPACE_LEGAL_NOTICE_LABEL": "Descripción",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Esta página se muestra en la parte inferior de su plataforma, debajo del pie de página, con información pre-rellenada por Fluicity Engage como anfitrión y editor técnico de la solución.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "Los avisos legales permiten informar a los usuarios sobre la identidad del responsable del sitio, el proveedor de alojamiento y las condiciones de edición de la plataforma.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Son obligatorias para cualquier sitio institucional o público, y refuerzan la transparencia de su enfoque.",
      "SPACE_PRIVACY_POLICY": "Política de privacidad",
      "SPACE_PRIVACY_POLICY_LABEL": "Descripción",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Esta página se muestra en la parte inferior de su plataforma, debajo del pie de página, con información de Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "La política de privacidad permite informar a los participantes sobre el tratamiento de sus datos personales. Puede añadir aquí detalles específicos de su organización (por ejemplo: duración de conservación específica, contacto DPO, uso interno de los datos, etc.).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Este texto complementa la <link>política de privacidad de Fluicity Engage</link>, responsable técnico de la plataforma y garante del cumplimiento del RGPD. La adición de su propio texto sigue siendo opcional según el uso que haga de la plataforma.",
      "SPACE_TERMS_OF_USE": "Condiciones de uso",
      "SPACE_TERMS_OF_USE_LABEL": "Descripción",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Agregar aquí el contenido de tus condiciones de uso personalizadas.",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "Las condiciones de uso definen las reglas de buen uso de su espacio, los derechos y responsabilidades de los usuarios, así como sus compromisos como organizador de la iniciativa. (ej: reglas de moderación, derechos de participación, etc).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Este texto complementa los <link>CGU de Fluicity Engage</link>, como tercero de confianza y editor de la plataforma. La adición de su propio texto sigue siendo opcional según el uso que haga de la plataforma.",
      "TOPICS": "Temáticas",
      "TOPICS_DESCRIPTION": "Las temáticas permiten categorizar tus contenidos para ayudar a los usuarios a encontrar los contenidos por su centro de interés.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mi-pagina",
      "UPDATED_SUCCESSFULLY": "Su espacio ha sido actualizado exitosamente.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Enviar una notificación automáticamente al iniciar una consulta y para todas sus fases de participación."
        },
        "TITLE": "Notificaciones",
        "WEEKLY": {
          "LABEL": "Enviar un resumen de noticias semanal a los suscriptores (nuevos artículos, nuevos eventos y recordatorios para participar en una consulta)."
        }
      },
      "WEBSITE_URL_LABEL": "Sitio web",
      "WEBSITE_URL_PLACEHOLDER": "https://www.misitio.com",
      "YOUR_SPACE": "Tu espacio"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Espacios relacionados",
        "SEE_MORE": "Ver más ({count})"
      },
      "FOOTER": {
        "TITLE": "¡Mantengámonos en contacto!"
      },
      "SEE": "Ver",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Ningún inscrito} one {{count} inscrito} other {{count} inscritos}}",
        "IDEAS_COUNT": "{count, plural, =0 {Ninguna participación} one {{count} participación} other {{count} participaciones}}"
      },
      "SPONSOR": "Este espacio está asociado con"
    },
    "NEWS": {
      "EMPTY_STATE": "Encontrarás aquí los artículos y eventos publicados por la organización.",
      "TITLE": "{count, plural, =0 {Ninguna noticia} one {{count} noticia} other {{count} noticias}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Consultar la política de privacidad de Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Formulario de inscripción",
        "TAB_INVITATIONS": "Invitaciones"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Notificaciones"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Apariencia",
        "TAB_LANGUAGES": "Idiomas",
        "TAB_TOPICS": "Temáticas"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Avisos legales",
        "TAB_PRIVACY_POLICY": "Política de privacidad",
        "TAB_TERMS_OF_USE": "Condiciones de uso"
      },
      "PAGES": {
        "TAB_ABOUT": "Acerca de",
        "TAB_FOOTER": "Pie de página",
        "TAB_HOME": "Inicio",
        "TAB_NAVIGATION": "Barra de navegación"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Consultar los términos de uso de Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Informaciones generales",
    "PROF_CATEGORY_ID": {
      "LABEL": "Categoría socio-profesional"
    },
    "SECTION": {
      "HEADER": "Formulario de inscripción",
      "SUBTITLE1": "El formulario de inscripción es una herramienta que permite recopilar datos sobre los usuarios.",
      "SUBTITLE2": "Configure los campos de recolección según sus necesidades, asegurándose de cumplir con el RGPD."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Edad"
    },
    "AI": {
      "ACTIONS": "Aspiraciones de los usuarios:",
      "ACTIONS_TOOLTIP": "Este resumen de las aspiraciones de los usuarios es generado por IA. Su objetivo es ayudarte a interpretar las contribuciones originales realizadas por los participantes. Se basa en las contribuciones agrupadas a continuación.",
      "ADD_CLUSTER": "Añadir un grupo temático",
      "ADD_SUB_CLUSTER": "Agregar un subgrupo",
      "CLUSTER": {
        "SUMMARY": "Descripción del grupo temático",
        "SUMMARY_PLACEHOLDER": "La descripción del grupo temático",
        "TITLE": "Nombre del grupo temático",
        "TITLE_PLACEHOLDER": "El nombre del grupo temático se utilizará por la IA para agrupar las contribuciones."
      },
      "DELETE": "Eliminar",
      "DESCRIPTION": "Descripción:",
      "EDIT": "Modificar",
      "EDIT_CLUSTER": "Modificar el tema",
      "EDIT_SUB_CLUSTER": "Modificar el subgrupo",
      "EXPLAIN_AI": "Utilizamos inteligencia artificial para examinar cuidadosamente las contribuciones a esta consulta. Nuestro objetivo es agruparlas en diferentes categorías en función de su similitud, para ofrecerle una mejor comprensión de las tendencias, aspiraciones clave y propuestas emergentes. Este enfoque le permitirá comprender mejor las ideas y opiniones emergentes dentro de la consulta.",
      "GENERATE": "Iniciar el análisis",
      "IDEAS": "Contribuciones originales:",
      "IN_FAVOR": "Para",
      "MOVE_IDEA": "Mover",
      "MOVE_IDEA_TITLE": "Cambiar de grupo temático o de subgrupo",
      "OPPOSED": "En contra",
      "SUB_CLUSTER": {
        "SUMMARY": "Descripción del subgrupo",
        "SUMMARY_PLACEHOLDER": "La descripción del subgrupo",
        "TITLE": "Nombre del subgrupo",
        "TITLE_PLACEHOLDER": "El nombre del subgrupo temático será utilizado por la IA para agrupar las contribuciones."
      },
      "TOAST": "El análisis de IA está en curso. Esto puede tomar algunos minutos."
    },
    "CITIES": {
      "TITLE": "Lugar de residencia"
    },
    "CLUSTERS": "Grupos temáticos",
    "CLUSTERS_TOOLTIP": "Las diferentes aspiraciones de los usuarios son agrupadas por la IA en una o varias temáticas",
    "CLUSTER_OTHER": "Otro",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Desde los últimos 7 días"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, 0 {contribución} one {contribución} other {contribuciones}}",
    "DAY": "Día",
    "DELIVERABILITY": "Délivrabilidad",
    "IDEAS_STATUSES": {
      "TITLE": "Estado de las contribuciones"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Comentario} one {Comentario} other {Comentarios}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Respuesta} one {Respuesta} other {Respuestas}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Participante} one {Participante} other {Participantes}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Votar en contra} one {Votar en contra} other {Votos en contra}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Voto para} one {Voto para} other {Votos para}}"
    },
    "MONTH": "Meses",
    "NO_DATA": "No hay datos disponibles en este momento.",
    "PARTICIPANTS": {
      "TITLE": "Participantes",
      "TOTAL_PARTICIPANTS": "Participantes",
      "TOTAL_TARGETED_USERS": "Usuarios registrados"
    },
    "PARTICIPANTS_PROGRESSION": "Evolución de los participantes",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Acciones realizadas por los participantes",
      "TOTAL_COMMENTS": "Comenta",
      "TOTAL_IDEAS": "Hace una contribución",
      "TOTAL_NO_ACTIONS": "Ninguna acción",
      "TOTAL_STUDY_ANSWERS": "Respuestas de la encuesta",
      "TOTAL_VOTES": "Votar"
    },
    "PARTICIPATION_PROGRESSION": "Evolución de la participación",
    "PERFORMANCE": "Rendimiento",
    "PROF_CATEGORIES": {
      "TITLE": "Categoría socio-profesional"
    },
    "REFERRERS": "Fuentes de tráfico",
    "SECTIONS": {
      "ACTIVITY": "Actividad",
      "ENGAGEMENT": "Compromiso",
      "PARTICIPANTS_PROFILE": "Profile de los participantes"
    },
    "SEX": {
      "TITLE": "Sexo",
      "TOTAL_": "No especificado",
      "TOTAL_FEMALE": "Mujer",
      "TOTAL_MALE": "Hombre",
      "TOTAL_UNSPECIFIED": "No especificado"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Objectivos de inscripciones",
      "TOTAL_TARGETED_USERS": "Objetivo",
      "TOTAL_USERS": "Usuarios registrados"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Evolución de las inscripciones"
    },
    "TAB_AI": "Análisis IA (beta)",
    "TAB_ATTENDEES": "Participantes",
    "TAB_CONTENTS": "Contenidos",
    "TAB_DETAILS": "Detalles",
    "TAB_EMAILS": "Correo electrónico con el autor",
    "TAB_LIST": "Lista",
    "TAB_PARTICIPATION": "Participación",
    "TAB_PRIVATE_NOTES": "Notas internas",
    "TAB_PROPOSALS": "Contribuciones",
    "TAB_RESPONSES": "Respuestas",
    "TAB_RESULTS": "Resultados",
    "TAB_SETTINGS": "Configuración",
    "TAB_STATS": "Estadísticas",
    "TAB_VOTES": "Votos",
    "TARGETED_POPULATION": "Demografía (fuente oficial)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Título",
      "COL_TOTAL": "Participantes",
      "SUBTITLE": "Total de contribuciones, comentarios, votos o respuestas a la encuesta",
      "TITLE": "Consultas populares"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Título",
      "COL_TOTAL": "Visitantes",
      "COL_TYPE": "Tipo",
      "TITLE": "Contenidos más visitados"
    },
    "TOTAL_ANSWERS": "{answersCount} de {totalCount} {totalCount, plural, 0 {respuesta} one {respuesta} other {respuestas}}",
    "TOTAL_BOUNCED": "Rebondado",
    "TOTAL_CLICKED": "Clicado",
    "TOTAL_COMMENTS": "Comentarios",
    "TOTAL_COMMUNICATIONS": "Noticias",
    "TOTAL_CONSULTATIONS": "Consultas",
    "TOTAL_DELIVERED": "Emitido",
    "TOTAL_IDEAS": "Contribuciones",
    "TOTAL_OFFLINE_VOTES": "Votos sin conexión",
    "TOTAL_ONLINE_VOTES": "Votos en línea",
    "TOTAL_OPENED": "Abierto",
    "TOTAL_PARTICIPANTS": "Participantes",
    "TOTAL_REJECTED": "Rechazado",
    "TOTAL_RESPONDENTS": "Répondants",
    "TOTAL_SENT": "Enviado",
    "TOTAL_STUDY_ANSWERS": "Respuestas de la encuesta",
    "TOTAL_USERS": "Usuarios registrados",
    "TOTAL_VOTERS": "Votantes",
    "TOTAL_VOTES": "Votos",
    "UNIQUE_VISITS": "Visitas únicas",
    "USERS_WHO_ANSWERED": "{count} {count, plural, 0 {respondiendo} one {respondiendo} other {respondiendo}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Acciones realizadas por los usuarios",
      "TOTAL_COMMENTS": "Comenta",
      "TOTAL_IDEAS": "Hace una contribución",
      "TOTAL_NO_ACTIONS": "Ninguna acción",
      "TOTAL_STUDY_ANSWERS": "Respuestas de la encuesta",
      "TOTAL_VOTES": "Voto"
    },
    "WEEK": "Semana",
    "WORD_CLOUD": "Nube de palabras"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - Has superado el límite de caracteres.",
    "LENGTH_ERROR_TEXT": "Has llegado al límite de caracteres."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Carrusel",
    "BUTTON_GROUP": "Cambiar modo de visualización",
    "BUTTON_LIST": "Lista",
    "BUTTON_MAP": "Tarjeta"
  },
  "TOKENS": "{count, plural, =0 {Ningún token} one {{count} token} other {{count} tokens}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Añadir una temática",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Uno o varios contenidos de su plataforma están actualmente categorizados bajo esta temática.",
      "DESCRIPTION_2": "Al modificarla o eliminarla, cambiarás la clasificación de estos contenidos.",
      "TITLE": "¿Está seguro?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Ver el texto original",
    "SUCCESS": "La traducción se ha realizado con éxito.",
    "TRANSLATE": "Traducir",
    "TRANSLATING": "Traducción en curso..."
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Los bloques permiten personalizar tu página destacando información en formato de texto, imagen y video.",
        "SECTION_HEADER": "Bloques"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Los bloques permiten personalizar tu página destacando información en formato de texto, imagen, video, así como los contenidos destacados.",
        "SECTION_HEADER": "Bloques"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Informar de un problema en privado",
          "TITLE": "Anomalía"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Texto, imagen y video",
          "TITLE": "Personalizado"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Contacto privado a través de la plataforma",
          "TITLE": "Mensajería"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Consulta destacada, en curso y próxima",
          "TITLE": "Consulta"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Artículo y evento",
          "TITLE": "Noticias"
        },
        "FOLDERS": {
          "DESCRIPTION": "Carpeta y subcarpeta",
          "TITLE": "Expediente"
        },
        "KPIS": {
          "DESCRIPTION": "Número de inscritos, contribuciones y consultas",
          "TITLE": "Algunas cifras"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Participación de los usuarios",
          "TITLE": "Contribución"
        },
        "SPACE_INFO": {
          "TITLE": "Barra superior"
        }
      },
      "LAYER_ADD_MEDIA": "Agregar un medio",
      "LAYER_ADD_PICTURE": "Imagen",
      "LAYER_ADD_VIDEO": "Vidéo",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "Los textos están centrados con respecto al medio.",
          "LABEL": "Centrado"
        },
        "LEFT": {
          "DESCRIPTION": "Los textos están a la izquierda del medio.",
          "LABEL": "A la izquierda"
        },
        "RIGHT": {
          "DESCRIPTION": "Los textos están a la derecha del medio.",
          "LABEL": "A la derecha"
        },
        "TITLE": "Visualización"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Todas las noticias",
        "ARTICLE": "Artículo",
        "EVENT": "Evento",
        "LABEL": "Tipo",
        "PINNED": "Destacado"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Todas las consultas",
        "ENDED": "Consultas finalizadas",
        "LABEL": "Tipo",
        "ONGOING": "Consultas en curso",
        "PINNED": "Destacado"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Consultas iniciadas",
        "CONTRIBUTIONS_COUNT": "Contribuciones concretadas",
        "PARTICIPATIONS_COUNT": "Participaciones (contribuciones, respuestas de encuestas, votos y comentarios realizados)",
        "TITLE": "Mostrar el número de:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Inscritos y participaciones",
        "USERS_COUNT": "Inscritos"
      },
      "LAYER_CTA_LABEL": "Etiqueta del botón",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Lo que desea mostrar en el botón",
      "LAYER_CTA_URL": "URL del botón",
      "LAYER_CTA_URL_PLACEHOLDER": "Enlace a una página o documento",
      "LAYER_DESCRIPTION_LABEL": "Descripción",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Agrega aquí el contenido textual del bloque. Sé conciso y contundente.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Todos los expedientes",
        "CHILDREN": "Contenidos de un expediente",
        "CUSTOM": "Personalizado",
        "SELECT_FOLDER": "Seleccionar una carpeta",
        "SELECT_FOLDERS": "Seleccionar las carpetas",
        "TYPE_LABEL": "Tipo de filtrado"
      },
      "LAYER_PICTURE_LABEL": "Imagen",
      "LAYER_TITLE_LABEL": "Título",
      "LAYER_TITLE_PLACEHOLDER": "Establezca un título para el bloque",
      "SELECTION_DIALOG": {
        "TITLE": "Crear un bloque"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Contactar al usuario",
      "INVITE": "Invitar",
      "UNREGISTER": "Cancelar suscripción",
      "UPDATE_ROLE": "Definir el rol"
    },
    "EXPORT": "Exportar datos de usuarios",
    "EXPORT_SUCCESS_TOAST": "La exportación está en curso. Recibirás un correo electrónico tan pronto como esté listo.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Lista de correos electrónicos separados por comas",
        "EMAILS_PLACEHOLDER": "Ejemplo: usuario1@organizacion.com, usuario2@asociacion.org",
        "MESSAGE_LABEL": "Mensaje de invitación",
        "MESSAGE_PLACEHOLDER": "Ingresa un mensaje de invitación corto e inspirador, que motive a los invitados a unirse a su espacio y participar.",
        "SUCCESS_TOAST": "Los usuarios han sido invitados exitosamente.",
        "TITLE": "Invitar usuarios",
        "WARNING": "Asegúrese de obtener el consentimiento de los usuarios antes de utilizar su correo electrónico para invitarlos."
      },
      "DELETE_FORM": {
        "CONTENT": "Estás a punto de cancelar la invitación enviada a <b>{email}</b>. ¿Estás seguro de que quieres continuar?",
        "DELETE": "Eliminar",
        "TITLE": "Eliminar la invitación"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "Está a punto de dar de baja al usuario “<strong>{userName}</strong>” de su espacio de participación.",
      "DESCRIPTION_2": "Si el espacio es privado, el usuario correspondiente ya no podrá acceder al espacio. Deberás volver a invitarlo para cancelar esta operación.",
      "DESCRIPTION_3": "Si el espacio es público, el usuario en cuestión no podrá participar más. Deberá volver a registrarse para cancelar esta operación.",
      "DESCRIPTION_4": "¿Estás seguro de que quieres proceder con la operación?",
      "TITLE": "Eliminar al usuario"
    }
  },
  "USER_AVATAR": "Avatar del usuario",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Has alcanzado el número máximo de votos",
    "MAX_VOTES_WARNING": "{count, plural, =0 {No puede apoyar más contribuciones} one {Puede apoyar <strong># contribución</strong> adicional.} other {Puede apoyar <strong># contribuciones</strong> adicionales.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {Ya has apoyado suficientes contribuciones} one {Aún falta <strong># apoyo</strong> para validar su participación.} other {Aún faltan <strong># apoyos</strong> para validar su participación.}}",
    "VALID_PARTICIPATION": "Su participación ha sido validada."
  },
  "VIEW_ALL": "Ver todo",
  "VIRUS_SCAN": {
    "CLEAN": "Análisis antivirus ok",
    "INFECTED": "Archivo infectado",
    "INFECTED_ATTACHMENTS_ERROR": "Un documento parece estar infectado. Por favor, elimínelo antes de guardar.",
    "NO_SCAN": "Análisis antivirus en curso"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Fecha de nacimiento: {birthdate}",
        "DELETE_VOTE": "Eliminar el voto",
        "EMPTY": "No especificado",
        "IMPORTED_AT": "Importado el {date}",
        "KEEP_BOTH": "Conservar ambos",
        "PARTICIPATED_AT": "Participación el {date}"
      },
      "DESCRIPTION": "El análisis de duplicados tiene en cuenta el nombre y el apellido de los usuarios. Para tratar el duplicado, elija el voto que desea eliminar entre las dos participaciones.",
      "FOUND_DUPLICATES": "Tienes <b>{count, plural, one {{count} votante identificado duplicado} other {{count} votantes identificados duplicados}}</b>. Última actualización <b>{timeAgo}</b>",
      "LOADING": "Vérification en curso…",
      "NO_DUPLICATES": "Ningún duplicado identificado. Última actualización hace <b>{timeAgo}</b>",
      "PLACEHOLDER": "Encontrará aquí los votantes identificados como duplicados.",
      "REFRESH": "Actualizar",
      "START_CHECK": "Iniciar verificación",
      "TITLE": "Gestionar duplicados"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Introduzca la URL"
    },
    "PLACEHOLDER": "Empieza a escribir..."
  }
}